export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Cartier Philanthropy - A decade of effective philanthropy",
    "shortTitle": "",
    "description": "",
    "width": 714,
    "height": 868,
    "currentLanguage": "EN",
    "languages": [{
      "code": "EN",
      "text": "English",
      "href": "https://reports.cartierphilanthropy.org/a-decade-of-effective-philanthropy/en"
    },{
      "code": "FR",
      "text": "French",
      "href": "https://reports.cartierphilanthropy.org/a-decade-of-effective-philanthropy/fr"
    }],
    "basePath": "/a-decade-of-effective-philanthropy/en",
    // "basePath": "",
    "companyLogo": "logo.png",
    "publishURL": "https://reports.cartierphilanthropy.org/a-decade-of-effective-philanthropy/en/static/_thumbs",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": true,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": true,
      "downloadPath": '/a-decade-of-effective-philanthropy/en/static/_content/Cartier-Philanthropy-a-Decade-of-Effective-Philanthropy.pdf',
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": true,
      "editionsEnabled": false,
      "mobileSwitch": false,
      "guideEnabled": false,
      "galleryCaptions": {}
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleC 2-logo" style="top:236px;left:calc(991px - 32px);" src="/a-decade-of-effective-philanthropy/en/static/_content/2-logo-1.png">
        <img class="abs halfScale 2-title" style="top:526px;left:calc(1105px - 32px);" src="/a-decade-of-effective-philanthropy/en/static/_content/2-title-1.png">
        <img class="abs halfScaleC 2-logo" style="top:740px;left:calc(1054px - 32px);" src="/a-decade-of-effective-philanthropy/en/static/_content/2-logo-2.png">
      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim
            .staggerFromTo(cOf("2-logo"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.6, 1)
            .fromTo(cOf("2-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
        }

        function onPageLeave() {
          pg2Anim.stop();
          resetNumbers("2-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "A DECADE O F E FFE C T I V E PHILANTHROPY"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale53 3-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/3-title-1.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/en/static/_content/3-pie-1.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/en/static/_content/3-pie-2.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/en/static/_content/3-pie-3.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/en/static/_content/3-pie-4.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/en/static/_content/3-pie-5.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/en/static/_content/3-pie-6.png">
        <h1 id="3-no" class="abs brillCutReg 3-no" style="top:176px;left:281px; font-size: 4.4em; font-weight: 300; color: #868687; padding: 0px; margin: 0px;"  data-number='{"to": 100, "comma": true}' ></h1>
        <h1 id="3-no" class="abs brillCutReg 3-no" style="top:286px;left:391px; font-size: 4.4em; font-weight: 300; color: #868687; padding: 0px; margin: 0px;"  data-number='{"to": 50, "preppend": "+"}' ></h1>

        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:476px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 52, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:500px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 25, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:523px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 10, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:547px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 6, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:570px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 1, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:594px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 6, "append": "%"}' ></h1>
        `,
        "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();
          pg3Anim
            .fromTo(cOf("3-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .staggerFromTo(cOf("3-pie"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.9)
          
          animateNumbers("3-no", 1.3)
        }
        
        function onPageLeave() {
          pg3Anim.stop();
          resetNumbers("3-no");
          removeContentLinks();
          removeContentLinksThree();
        }
        `,
        "searchText": "BUDGET ALLOCATION  100  million Swiss francs invested by 2022  +50 Geographic distribution 5 2% Africa 2 5% Asia 1 0% Central & Latin America 6 % Europe* 1% Middle East 6% Other*  *includes exceptional support during the Covid crisis (2020-2022)  2-  countries"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
        <h1 id="3-no" class="abs brillCutReg 3-no" style="top:241px;left:81px; font-size: 4.4em; font-weight: 300; color: #868687; padding: 0px; margin: 0px;"  data-number='{"to": 80, "preppend": "+"}' ></h1>

        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:476px;left:89px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 41, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:476px;left:295px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 23, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:476px;left:412px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 21, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:476px;left:519px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 15, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:766px;left:99px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 33, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:766px;left:249px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px;margin: 0px;"  data-number='{"to": 24, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:766px;left:376px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 23, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:766px;left:482px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 20, "append": "%"}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();

          animateNumbers("3-no", 1.3)
        }

        function onPageLeave() {
          pg4Anim.stop();
          resetNumbers("3-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "+80  partners  By focus area 4 1% Access to basic services  33% Education  2 3% Women’s social and economic development  24% Health  2 1% Sustainable livelihoods and ecosystems  23% Water and sanitation  1 5% Emergency response  20% Nutrition  - 3"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 6-title" style="top:286px;left:333px;" src="/a-decade-of-effective-philanthropy/en/static/_content/6-title-1.png">
        <img class="abs halfScale 6-title" style="top:384px;left:357px;" src="/a-decade-of-effective-philanthropy/en/static/_content/6-text-1.png">
        <img class="abs halfScale 6-title" style="top:478px;left:357px;" src="/a-decade-of-effective-philanthropy/en/static/_content/6-text-2.png">
        <img class="abs halfScale 6-title" style="top:574px;left:357px;" src="/a-decade-of-effective-philanthropy/en/static/_content/6-text-3.png">
        <img class="abs halfScale 6-title" style="top:657px;left:357px;" src="/a-decade-of-effective-philanthropy/en/static/_content/6-text-4.png">

        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top: 379px; left: 353px; width: 186px; height: 44px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(7);" style="top: 476px; left: 353px; width: 219px; height: 44px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(8);" style="top: 571px; left: 353px; width: 298px; height: 44px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(42);" style="top: 652px; left: 353px; width: 278px; height: 61px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim
            .staggerFromTo(cOf("6-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg6Anim.stop();
          resetNumbers("6-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SUM M A RY  06  Message from the President  07  Strategic Advisor’s Message  08  10 years of collective impact across our key focus areas  42  The five lessons we learned from a decade of grant-making  XXX - 5"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 7-title" style="top:87px;left:88px;" src="/a-decade-of-effective-philanthropy/en/static/_content/7-title-1.png">

      <div class="contentLinkNone abs" style="top: 195px; left: 282px; width: 368px; height: 510px;" onclick="Publish.openArticle(0)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg7Anim = new TimelineMax();
          pg7Anim
            .fromTo(cOf("7-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        }

        function onPageLeave() {
          pg7Anim.stop();
          resetNumbers("7-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "MESSAGE FROM THE PRESIDENT Cartier’s mission is to find beauty wherever it may lie. We serve beauty and work to honour it every day, so it can flourish and last for generations. We see it as our responsibility, both as human beings and as a company, to nurture and protect the world’s beauty, making every effort to restore it when it has been eroded or shattered. And we see human life as an integral part of the beauty of the world. Beauty, as we conceive of it, is thus a demanding ideal that can only be served through care, respect, dignity and compassion.  CYRILLE VIGNERON CEO of Cartier, President of the Board, Cartier Philanthropy  Over the past 10 years, Cartier Philanthropy has worked tenaciously and effectively to improve the lives of the most vulnerable and marginalised communities on the planet, so that they are not only able to endure and survive hardship, but to live, enjoy and fully participate in the beauty of the world. A girl that successfully finishes her education, a thriving farming community, a safe place to find sanctuary and rebuild a new life, a healthy baby… These are all beauty. Living beauty. Cartier Philanthropy has been supporting organisations whose mission is to empower women, children and entire communities with the resources, skills and opportunities they need to live fulfilling lives. Strong long-term alliances have been created along the way, based on shared values and a mutual commitment to impactful philanthropy. The road ahead is still long. Indeed, on some days it can seem longer than it did 10 years ago. But every step forward and every life changed reaffirms our confidence and determination, while opening the way for others to join us in creating new beauty in the world.  6-"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 8-title" style="top:87px;left:72px;" src="/a-decade-of-effective-philanthropy/en/static/_content/8-title-1.png">
        <div class="contentLinkNone abs" style="top: 195px; left: 264px; width: 368px; height: 615px;" onclick="Publish.openArticle(1)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim
            .fromTo(cOf("8-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        }

        function onPageLeave() {
          pg8Anim.stop();
          resetNumbers("8-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "STRATEGIC ADVISOR’S MESSAGE What a journey the last 10 years have been! And what a privilege it has been to lead Cartier Philanthropy from promise to progress, building a portfolio of partner organisations of which we are incredibly proud. It’s a source of joy to see empowered and resourceful communities across the world overcoming great obstacles and once insurmountable barriers as they begin to live the lives they deserve.  PASCALE DE LA FRÉGONNIÈRE  Strategic Advisor to the Board, Cartier Philanthropy  Ten years ago, Cartier Philanthropy was founded to help build a world in which everyone can realise their potential. Over the past decade, we’ve focused on that vision strategically. We’ve chosen to concentrate on the most fragile places on Earth and we’ve gradually defined the perimeter of the issues we wanted to tackle, challenging in particular the inequalities that keep people in poverty. Philanthropy is all about collective action in pursuit of shared goals. In collaboration with our partners, we have tried to address these inequalities relentlessly, whether linked to gender, access to essential services or lack of material and social resources. This report sheds light on the impact we have achieved together and on the concrete changes that have contributed to improving the lives of those most in need. It is our way of honouring our partner organisations for their courage and determination to fight for the people they serve, no matter the difficulties - for their struggles are ours too. Conscious that true, lasting change only happens if we focus also on how we give in order to contribute to significant social impact, this report also shares some of the lessons we have learned along the way, helping us to become a better, more effective, accountable and collaborative foundation. Achieving an inclusive, equitable and safer society that offers everyone a chance to live a fulfilling life remains a moral imperative and the challenge of our time. Our commitment to get there is unchanged, as is our ambition to scale the interventions that work to match the level of need. - 7"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 10-title" style="top:382px;left:332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/10-title-1.png">
        <img class="abs halfScale 10-title" style="top:450px;left:332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/10-sub-1.png">
        <img class="abs halfScale 10-title" style="top:612px;left:357px;" src="/a-decade-of-effective-philanthropy/en/static/_content/10-text-1.png">
        <img class="abs halfScale 10-title" style="top:665px;left:357px;" src="/a-decade-of-effective-philanthropy/en/static/_content/10-text-2.png">
        <img class="abs halfScale 10-title" style="top:736px;left:357px;" src="/a-decade-of-effective-philanthropy/en/static/_content/10-text-3.png">
        <img class="abs halfScale 10-title" style="top:808px;left:357px;" src="/a-decade-of-effective-philanthropy/en/static/_content/10-text-4.png">

        <div class="contentLinkNone" onclick="Publish.goToPage(11);" style="top: 607px; left: 351px; width: 270px; height: 24px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(19);" style="top: 660px; left: 351px; width: 270px; height: 41px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(27);" style="top: 732px; left: 351px; width: 270px; height: 41px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(35);" style="top: 803px; left: 351px; width: 270px; height: 23px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim
            .staggerFromTo(cOf("10-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg10Anim.stop();
          resetNumbers("10-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "10 YEARS OF COLLECTIVE IMPACT ACROSS OUR KEY FOCUS AREAS 1.  ACCESS TO BASIC SERVICES 2. W  OMEN’S SOCIAL AND ECONOMIC DEVELOPMENT 3. S  USTAINABLE LIVELIHOODS AND ECOSYSTEMS 4. EMERGENCY RESPONSE XXX - 9"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "10 - X X X"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 12-title" style="top:380px;left:332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/11-title-1.png">
        <img class="abs halfScale 12-title" style="top:533px;left:331px;" src="/a-decade-of-effective-philanthropy/en/static/_content/12-text-1.png">
        <div class="12-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/en/static/_content/Cartier_Access to Basic Services_V9_Subbed.mp4')" style="top: 456px; left: 545px; filter: invert(1);">
          <img class="abs halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/en/static/_content/play.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim
            .staggerFromTo(cOf("12-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("12-play"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.3")
        }

        function onPageLeave() {
          pg12Anim.stop();
          resetNumbers("12-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACCESS TO BASIC SERVICES A thriving life is built on good health, a quality education, nutritious food, clean water and access to toilets - all of which are also fundamental human rights. Over the past ten years, we have partnered with dozens of organisations that work tirelessly and rigorously to improve access to these basic services in the world’s most remote areas. XXX - 11"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 13-title" style="top:106px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/13-title-1.png">
        <img class="abs halfScaleR 13-line" style="top:98px;left:-693px;" src="/a-decade-of-effective-philanthropy/en/static/_content/13-line-1.png">
        <h1 id="13-no" class="abs fancyCutMediumStretch 13-no" style="top: 402px; left: 120px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 30, "append": "%"}' ></h1>
        <img class="abs halfScale 13-text" style="top:435px;left:114px;" src="/a-decade-of-effective-philanthropy/en/static/_content/13-text-1.png">
        <img class="abs halfScale 13-image" style="top:560px;left:114px;" src="/a-decade-of-effective-philanthropy/en/static/_content/13-image-1.png">
        <img class="abs halfScaleR 13-line" style="top:420px;left:-93px;" src="/a-decade-of-effective-philanthropy/en/static/_content/13-line-2.png">
        <h1 id="13-no" class="abs fancyCutMediumStretch 13-no" style="top: 618px; left: 506px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 38, "append": "%"}' ></h1>
        <img class="abs halfScale 13-text" style="top:651px;left:498px;" src="/a-decade-of-effective-philanthropy/en/static/_content/13-text-2.png">
        <img class="abs halfScale 13-image" style="top:401px;left:358px;" src="/a-decade-of-effective-philanthropy/en/static/_content/13-image-2.png">
      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax();
          pg13Anim
            .fromTo(cOf("13-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("13-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("13-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no")[0])}}, 1.45)
            .fromTo(cOf("13-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("13-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("13-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("13-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no")[1])}}, 2.35)
            .fromTo(cOf("13-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("13-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)
        }

        function onPageLeave() {
          pg13Anim.stop();
          resetNumbers("13-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACCESS TO HEALTHCARE  Togo  30%  decrease in under-five mortality rate with Integrate Health’s community-led model over a five-year period in the Kozah district  Zambia  0  14%  national decrease  0  38%  15 15 30 30  12 - A CCE S S TO BA SIC SER VICES  reduction in student morbidity in Lusaka schools when teachers are trained as school health workers by Healthy Learners"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 14-line" style="top:98px;left:-1407px;" src="/a-decade-of-effective-philanthropy/en/static/_content/13-line-1.png">
        <h1 id="14-no" class="abs fancyCutMediumStretch 14-no" style="top: 634px; left: 241px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 33, "append": "%"}' ></h1>
        <img class="abs halfScale 14-line-b" style="top:441px;left:421px;" src="/a-decade-of-effective-philanthropy/en/static/_content/14-line-3.png">
        <img class="abs halfScale 14-text" style="top:668px;left:233px;" src="/a-decade-of-effective-philanthropy/en/static/_content/14-text-1.png">
        <img class="abs halfScale 14-image" style="top:569px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/14-image-1.png">
        <img class="abs halfScale 14-map" style="top:111px;left:79px;" src="/a-decade-of-effective-philanthropy/en/static/_content/14-map-1.png">
        <img class="abs halfScaleR 14-line" style="top:420px;left:-807px;" src="/a-decade-of-effective-philanthropy/en/static/_content/13-line-2.png">
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
          pg14Anim
            .fromTo(cOf("14-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("14-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("14-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("14-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("14-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("14-no")[0])}}, 2.35)
            .fromTo(cOf("14-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("14-line-b"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.65)
        }

        function onPageLeave() {
          pg14Anim.stop();
          resetNumbers("13-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "AFRICA  0  15  30  33%  decrease in infant mortality in areas of Ifanadiana district where Pivot worked from 2014−2021, compared to 48% increase in the rest of the district  M a d a g a sca r  AC C ES S TO BAS IC S ERVIC ES - 13"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 15-title" style="top:106px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/15-title-1.png">
        <img class="abs halfScaleR 15-line" style="top:187px;left:-814px;" src="/a-decade-of-effective-philanthropy/en/static/_content/15-line-1.png">
        <h1 id="15-no" class="abs fancyCutMediumStretch 15-no" style="top: 675px; left: 122px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 75, "append": "%"}' ></h1>
        <img class="abs halfScale 15-text" style="top:708px;left:114px;" src="/a-decade-of-effective-philanthropy/en/static/_content/15-text-1.png">
        <img class="abs halfScale originBC 15-image" style="bottom:209px;left:22px;" src="/a-decade-of-effective-philanthropy/en/static/_content/15-image-1.png">
        <img class="abs halfScaleR 15-line" style="top:267px;left:-274px;" src="/a-decade-of-effective-philanthropy/en/static/_content/15-line-2.png">
        <h1 id="15-no" class="abs fancyCutMediumStretch 15-no" style="top: 402px; left: 497px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 19, "append": "%"}' ></h1>
        <img class="abs halfScale 15-text" style="top:433px;left:493px;" src="/a-decade-of-effective-philanthropy/en/static/_content/15-text-2.png">
        <img class="abs halfScale originBC 15-image" style="bottom:336px;left:322px;" src="/a-decade-of-effective-philanthropy/en/static/_content/15-image-2.png">
        <img class="abs halfScaleC 15-image" style="top:463px;left:170px;" src="/a-decade-of-effective-philanthropy/en/static/_content/15-image-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();
          pg15Anim
            .fromTo(cOf("15-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("15-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("15-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("15-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("15-no")[0])}}, 1.6)
            .fromTo(cOf("15-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("15-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("15-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("15-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("15-no")[1])}}, 2.35)
            .fromTo(cOf("15-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("15-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.8)
        }

        function onPageLeave() {
          pg15Anim.stop();
          resetNumbers("15-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACCESS TO EDUCATION  E thi opi a  R wa n d a  75  19%  60  15 45  0 30  15  0  75%  of students in The Luminos Fund’s Second Chance programme are still attending school after six years 14 - A CCE S S TO BA SIC SER VICES  increase in emotional resilience for adolescents enrolled in CorStone’s resilience training in Rwanda"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 16-line" style="top:187px;left:-1528px;" src="/a-decade-of-effective-philanthropy/en/static/_content/15-line-1.png">
        <img class="abs halfScaleR 16-line" style="top:267px;left:-987px;" src="/a-decade-of-effective-philanthropy/en/static/_content/15-line-2.png">
        <img class="abs halfScaleR 16-line" style="top:170px;left:217px;" src="/a-decade-of-effective-philanthropy/en/static/_content/16-line-3.png">
        <img class="abs halfScale originBC 16-image" style="bottom:71px;left:175px;" src="/a-decade-of-effective-philanthropy/en/static/_content/16-image-1.png">
        <h1 id="16-no" class="abs fancyCutMediumStretch 16-no" style="top: 495px; left: 434px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 66, "append": "%"}' ></h1>
        <img class="abs halfScale 16-text" style="top:528px;left:427px;" src="/a-decade-of-effective-philanthropy/en/static/_content/16-text-1.png">
        <div class="abs" style="top: 581px; left: -1px; width: 5px; height: 241px; background: white;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();
          pg16Anim
            .fromTo(cOf("16-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("16-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("16-line")[2], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("16-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("16-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[0])}}, 2.65)
            .fromTo(cOf("16-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)
        }

        function onPageLeave() {
          pg16Anim.stop();
          resetNumbers("16-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "B a n g la d esh  66% 60  45  30  increase in literacy for children using Imagine Worldwide’s tech-enabled learning approach, demonstrated in Malawi and now undergoing testing in Bangladesh  15  0  AC C ES S TO BAS IC S ERVIC ES - 15"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 17-title" style="top:88px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/17-title-1.png">
        <img class="abs halfScaleR 17-line" style="top:318px;left:-50px;" src="/a-decade-of-effective-philanthropy/en/static/_content/17-line-1.png">
        <h1 id="17-no" class="abs fancyCutMediumStretch 17-no" style="top: 476px; left: 129px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 12600, "comma": true}' ></h1>
        <img class="abs halfScale 17-text" style="top:509px;left:118px;" src="/a-decade-of-effective-philanthropy/en/static/_content/17-text-1.png">
        <img class="abs halfScale originBC 17-image" style="bottom:54px;left:15px;" src="/a-decade-of-effective-philanthropy/en/static/_content/17-image-1.png">
        <img class="abs halfScaleR 17-line" style="top:305px;left:116px;" src="/a-decade-of-effective-philanthropy/en/static/_content/17-line-2.png">
        <h1 id="17-no" class="abs fancyCutMediumStretch 17-no" style="top: 596px; left: 131px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 300000, "comma": true}' ></h1>
        <h1 id="17-no" class="abs fancyCutMediumStretch 17-no" style="top: 726px; left: 501px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 12000, "comma": true, "preppend": "+"}' ></h1>
        <img class="abs halfScale 17-text" style="top:762px;left:493px;" src="/a-decade-of-effective-philanthropy/en/static/_content/17-text-2.png">
        <img class="abs halfScale originBC 17-image" style="bottom:155px;left:357px;" src="/a-decade-of-effective-philanthropy/en/static/_content/17-image-2.png">
        <img class="abs halfScaleC 17-image" style="top:288px;left:210px;" src="/a-decade-of-effective-philanthropy/en/static/_content/17-image-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();
          pg17Anim
            .fromTo(cOf("17-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("17-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("17-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("17-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[0])}}, 1.6)
            .fromTo(cOf("17-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("17-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[1])}}, 1.75)
            .fromTo(cOf("17-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("17-line")[1], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("17-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("17-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[2])}}, 2.5)
            .fromTo(cOf("17-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.65)
        }

        function onPageLeave() {
          pg17Anim.stop();
          resetNumbers("17-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACCESS TO WATER, SANITATION AND NUTRITION  G uatemal a  12,600  Haiti  farmers planted Semilla Nueva’s biofortified seeds in 2021, providing more nutritious corn to  300,000 people  +12,000  Haitians use SOIL’s container-based toilets and waste collection service  16 - A CCE S S TO BA SIC SER VICES"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 18-line" style="top:318px;left:-54px;" src="/a-decade-of-effective-philanthropy/en/static/_content/18-line-1.png">
        <img class="abs halfScale 18-text" style="top:599px;left:354px;" src="/a-decade-of-effective-philanthropy/en/static/_content/18-text-1.png">
        <img class="abs halfScale originBC 18-image" style="bottom:43px;left:-10px;" src="/a-decade-of-effective-philanthropy/en/static/_content/18-image-1.png">
      `,
      "script": `
        function onPageEnter() {
          pg18Anim = new TimelineMax();
          pg18Anim
            .fromTo(cOf("18-line"), 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("18-image"), 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("18-text"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
        }

        function onPageLeave() {
          pg18Anim.stop();
          resetNumbers("18-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "Cambod i a  1 in 4  rural households in Cambodia - 850,000 people - drink clean water every day through 1001fontaines’ water kiosks AC C ES S TO BAS IC S ERVIC ES - 17"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "18 - X X X"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 20-title" style="top:333px;left:332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/20-title-1.png">
        <img class="abs halfScale 20-title" style="top:533px;left:332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/20-text-1.png">
        <div class="20-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/en/static/_content/womens_engagement_V7_Hardsubbed.mp4')" style="    top: 456px; left: 660px; filter: invert(1);">
          <img class="abs halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/en/static/_content/play.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax();
          pg20Anim
            .staggerFromTo(cOf("20-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("20-play"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.3")
        }

        function onPageLeave() {
          pg20Anim.stop();
          resetNumbers("20-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT Over the past decade, we have supported our partners to tackle the power imbalances, gender prejudices and social and economic barriers that keep holding women back. Their remarkable achievements in health, reproductive rights, sustainable livelihoods, entrepreneurship, education and agency have helped to foster a more equal world. XXX - 19"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 21-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/21-title-1.png">
        <img class="abs halfScaleR 21-line" style="top:218px;left:-332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/21-line-1.png">
        <h1 id="21-no" class="abs fancyCutMediumStretch 21-no" style="top: 364px; left: 282px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 2000, "comma": true}' ></h1>
        <img class="abs halfScale 21-text" style="top:397px;left:266px;" src="/a-decade-of-effective-philanthropy/en/static/_content/21-text-1.png">
        <img class="abs halfScale originBC 21-image" style="bottom:520px;left:5px;" src="/a-decade-of-effective-philanthropy/en/static/_content/21-image-1.png">
        <h1 id="21-no" class="abs fancyCutMediumStretch 21-no" style="top: 364px; left: 98px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 770000, "preppend": "+", "comma": true}' ></h1>
        <img class="abs halfScale 21-text" style="top:395px;left:88px;" src="/a-decade-of-effective-philanthropy/en/static/_content/21-text-2.png">
        <img class="abs halfScaleR 21-line" style="top:381px;left:-323px;" src="/a-decade-of-effective-philanthropy/en/static/_content/21-line-2.png">
        <img class="abs halfScale originBC 21-image" style="bottom:106px;left:41px;" src="/a-decade-of-effective-philanthropy/en/static/_content/21-image-2.png">
        <h1 id="21-no" class="abs fancyCutMediumStretch 21-no" style="top: 741px; left: 302px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 0.8, "append": "%", "decimals": 1}' ></h1>
        <img class="abs halfScaleC 21-text" style="top:751px;left:149px;" src="/a-decade-of-effective-philanthropy/en/static/_content/21-text-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax();
          pg21Anim
            .fromTo(cOf("21-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("21-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("21-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[0])}}, 1.45)
            .fromTo(cOf("21-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("21-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("21-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[1])}}, 2.05)
            .fromTo(cOf("21-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("21-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("21-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("21-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[2])}}, 2.8)
            .fromTo(cOf("21-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
        }

        function onPageLeave() {
          pg21Anim.stop();
          resetNumbers("21-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "WOMEN’S HEALTH  Senegal  +770,000  unintended pregnancies have been averted in Senegal since 2011 through MSI Reproductive Choices’ services  2,000  maternal deaths prevented since 2011  = 100 maternal deaths  Uganda  0.8%  mother-to-child HIV transmission rate in Uganda, compared to 40% without mothers2mothers’ services 20 - W O ME N ’ S SO CIA L A N D ECO N O M IC D EVELOPMENT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 22-line" style="top:218px;left:-1046px;" src="/a-decade-of-effective-philanthropy/en/static/_content/21-line-1.png">
        <img class="abs halfScaleR 22-line" style="top:381px;left:-1037px;" src="/a-decade-of-effective-philanthropy/en/static/_content/21-line-2.png">
        <h1 id="22-no" class="abs fancyCutMediumStretch 22-no" style="top: 738px; left: 359px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 120000, "comma": true}' ></h1>
        <img class="abs halfScale 22-text" style="top:773px;left:347px;" src="/a-decade-of-effective-philanthropy/en/static/_content/22-text-1.png">
        <img class="abs halfScale originBC 22-image" style="bottom:50px;left:-119px;" src="/a-decade-of-effective-philanthropy/en/static/_content/22-image-1.png">
        <img class="abs halfScaleR 22-line-b" style="top:467px;left:237px;" src="/a-decade-of-effective-philanthropy/en/static/_content/22-line-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg22Anim = new TimelineMax();
          pg22Anim
            .fromTo(cOf("22-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("22-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("22-line-b"), 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)
            .fromTo(cOf("22-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[0])}}, 2.95)
            .fromTo(cOf("22-text"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)
            .fromTo(cOf("22-image"), 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.15)
        }

        function onPageLeave() {
          pg22Anim.stop();
          resetNumbers("22-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "AFRICA  Zambia  120,000  women in Zambia treated for depression through StrongMinds’ group therapy model  WOMEN’S S OC IAL AND EC ONOMIC DEVELOPMENT - 21"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 23-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/23-title-1.png">
        <img class="abs halfScaleR 23-line" style="top:221px;left:-721px;" src="/a-decade-of-effective-philanthropy/en/static/_content/23-line-1.png">
        <h1 id="23-no" class="abs fancyCutMediumStretch 23-no" style="top: 274px; left: 434px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 1.1, "decimals": 1, "append": "M"}' ></h1>
        <img class="abs halfScale 23-text" style="top:310px;left:429px;" src="/a-decade-of-effective-philanthropy/en/static/_content/23-text-1.png">
        <img class="abs halfScale originBC 23-image" style="bottom:467px;left:172px;" src="/a-decade-of-effective-philanthropy/en/static/_content/23-image-1.png">
        <h1 id="23-no" class="abs fancyCutMediumStretch 23-no" style="top: 503px; left: 100px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 15000, "comma": true}' ></h1>
        <img class="abs halfScale 23-text" style="top:430px;left:88px;" src="/a-decade-of-effective-philanthropy/en/static/_content/23-text-2.png">
        <img class="abs halfScale originBC 23-image" style="bottom:63px;left:331px;" src="/a-decade-of-effective-philanthropy/en/static/_content/23-image-2.png">
        <h1 id="23-no" class="abs fancyCutMediumStretch 23-no" style="top: 590px; left: 521px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 90, "append": "%"}' ></h1>
        <img class="abs halfScaleC 23-image" style="top:488px;left:-59px;" src="/a-decade-of-effective-philanthropy/en/static/_content/23-image-3.png">
        <img class="abs halfScaleC 23-text" style="top:600px;left:477px;" src="/a-decade-of-effective-philanthropy/en/static/_content/23-text-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax();
          pg23Anim
            .fromTo(cOf("23-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("23-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("23-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("23-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[0])}}, 1.6)
            .fromTo(cOf("23-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("23-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("23-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[1])}}, 2.2)
            .fromTo(cOf("23-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("23-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.8)
            .fromTo(cOf("23-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[2])}}, 2.95)
            .fromTo(cOf("23-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)
        }

        function onPageLeave() {
          pg23Anim.stop();
          resetNumbers("23-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "WOMEN’S EDUCATION AND LIFE SKILLS 1.1M Indian girls back in school thanks to Educate Girls  India  15,000  community volunteers make up Educate Girls’ team  = 250 community volunteers  100%  90%  student retention rate  0%  22 - W O ME N ’ S SO CIA L A N D ECO N O M IC D EVELOPMENT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 24-line" style="top:221px;left:-1299px;" src="/a-decade-of-effective-philanthropy/en/static/_content/24-line-1.png">
        <img class="abs halfScaleR 24-line" style="top:276px;left:156px;" src="/a-decade-of-effective-philanthropy/en/static/_content/24-line-2.png">
        <img class="abs halfScaleR 24-line" style="top:420px;left:313px;" src="/a-decade-of-effective-philanthropy/en/static/_content/24-line-3.png">
        <img class="abs halfScale originBC 24-image" style="bottom:123px;left:-40px;" src="/a-decade-of-effective-philanthropy/en/static/_content/24-image-1.png">
        <h1 id="24-no" class="abs fancyCutMediumStretch 24-no" style="top: 670px; left: 137px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 79, "append": "%"}' ></h1>
        <img class="abs halfScale 24-text" style="top:755px;left:72px;" src="/a-decade-of-effective-philanthropy/en/static/_content/24-text-1.png">
        <h1 id="24-no" class="abs fancyCutMediumStretch 24-no" style="top: 707px; left: 400px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 23, "append": "%"}' ></h1>
        <img class="abs halfScale 24-text" style="top:741px;left:391px;" src="/a-decade-of-effective-philanthropy/en/static/_content/24-text-2.png">
        <img class="abs halfScale originBC 24-image" style="bottom:133px;left:428px;" src="/a-decade-of-effective-philanthropy/en/static/_content/24-image-2.png">
      `,
      "script": `
        function onPageEnter() {
          pg24Anim = new TimelineMax();
          pg24Anim
            .fromTo(cOf("24-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("24-line")[1], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("24-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("24-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("24-no")[0])}}, 1.9)
            .fromTo(cOf("24-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("24-line")[2], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("24-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("24-no")[1])}}, 2.5)
            .fromTo(cOf("24-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("24-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)
        }

        function onPageLeave() {
          pg24Anim.stop();
          resetNumbers("23-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "B a ng l a d e s h  Ca m b o d i a  79% 23%  of Room to Read’s graduates either enrolled in further education or found work within the first year of graduation  reduction in girls’ drop-out rate from secondary school thanks to Room to Read’s support WOMEN’S S OC IAL AND EC ONOMIC DEVELOPMENT - 23"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 25-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-title-1.png">
        <img class="abs halfScaleR 25-line" style="top:241px;left:-542px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-line-1.png">
        <img class="abs halfScaleR 25-line" style="top:377px;left:-150px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-line-2.png">
        <h1 id="25-no" class="abs fancyCutMediumStretch 25-no" style="top: 357px; left: 96px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 116000, "comma": true}' ></h1>
        <img class="abs halfScale 25-text" style="top:394px;left:86px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-text-1.png">
        <img class="abs halfScale originBC 25-image" style="bottom:519px;left:37px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-image-1.png">
        <h1 id="25-no" class="abs fancyCutMediumStretch 25-no" style="top: 341px; left: 425px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 558, "append": "%"}' ></h1>
        <img class="abs halfScale 25-text" style="top:735px;left:362px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-text-2.png">
        <img class="abs halfScale originBC 25-image" style="bottom:147px;left:307px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-image-2.png">
        <h1 id="25-no" class="abs fancyCutMediumStretch 25-no" style="top: 575px; left: 277px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 135, "append": "%"}' ></h1>
        <img class="abs halfScaleC 25-image" style="top:560px;left:98px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-image-3.png">
        <img class="abs halfScaleC 25-text" style="top:719px;left:97px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-text-3.png">
        <img class="abs halfScaleC 25-text" style="top:769px;left:-48px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-text-4.png">
      `,
      "script": `
        function onPageEnter() {
          pg25Anim = new TimelineMax();
          pg25Anim
            .fromTo(cOf("25-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("25-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("25-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("25-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("25-no")[0])}}, 1.6)
            .fromTo(cOf("25-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("25-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("25-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("25-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("25-no")[1])}}, 2.35)
            .fromTo(cOf("25-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("25-image")[2], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("25-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("25-no")[2])}}, 2.8)
            .fromTo(cOf("25-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("25-text")[3], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)
        }

        function onPageLeave() {
          pg25Anim.stop();
          resetNumbers("25-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "WOMEN’S ECONOMIC OPPORTUNITIES  116,000  558%  Ghana  people benefited from Saha Global’s 317 women-led water treatment businesses in Ghana  135% Rwanda  $20.84  $46.20  average increase in monthly earnings  $20.97  $138.60  average increase in monthly saving  for participants in Women for Women International’s programme in Rwanda, 2017−2020 24 - W O ME N ’ S SO CIA L A N D ECO N O M IC D EVELOPMENT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 26-line" style="top:241px;left:-1257px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-line-1.png">
        <img class="abs halfScaleR 26-line" style="top:377px;left:-864px;" src="/a-decade-of-effective-philanthropy/en/static/_content/25-line-2.png">
        <img class="abs halfScaleR 26-line" style="top:372px;left:-367px;" src="/a-decade-of-effective-philanthropy/en/static/_content/26-line-3.png">
        <img class="abs halfScaleR 26-line" style="top:314px;left:345px;" src="/a-decade-of-effective-philanthropy/en/static/_content/26-line-4.png">
        <h1 id="26-no" class="abs fancyCutMediumStretch 26-no" style="top: 722px; left: 86px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 253908, "comma": true}' ></h1>
        <h1 id="26-no" class="abs fancyCutMediumStretch 26-no" style="top: 722px; left: 242px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 29, "append": "%"}' ></h1>
        <h1 id="26-no" class="abs fancyCutMediumStretch 26-no" style="top: 757px; left: 524px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 14000, "comma": true, "preppend": "+"}' ></h1>
        <img class="abs halfScale 26-text" style="top:752px;left:70px;" src="/a-decade-of-effective-philanthropy/en/static/_content/26-text-1.png">
        <img class="abs halfScale 26-text" style="top:752px;left:234px;" src="/a-decade-of-effective-philanthropy/en/static/_content/26-text-2.png">
        <img class="abs halfScale 26-text" style="top:790px;left:514px;" src="/a-decade-of-effective-philanthropy/en/static/_content/26-text-3.png">
        <img class="abs halfScaleC 26-image" style="bottom:87px;left:-20px;" src="/a-decade-of-effective-philanthropy/en/static/_content/26-image-1.png">
        <img class="abs halfScaleC 26-image" style="bottom:66px;left:225px;" src="/a-decade-of-effective-philanthropy/en/static/_content/26-image-2.png">
        <img class="abs halfScaleC 26-image" style="top:550px;left:457px;" src="/a-decade-of-effective-philanthropy/en/static/_content/26-image-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax();
          pg26Anim
            .fromTo(cOf("26-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("26-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("26-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("26-line")[2], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("26-line")[3], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("26-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("26-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("26-no")[0])}}, 2.8)
            .fromTo(cOf("26-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("26-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("26-no")[1])}}, 3.1)
            .fromTo(cOf("26-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.25)
            .fromTo(cOf("26-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.4)
            .fromTo(cOf("26-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.55)
            .fromTo(cOf("26-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("26-no")[2])}}, 3.7)
            .fromTo(cOf("26-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.85)
        }

        function onPageLeave() {
          pg26Anim.stop();
          resetNumbers("26-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "AFRICA  Ethiopia  Ke n ya  253,908  women and children supported by BOMA  29%  = 500 businesses  income increase for extremely poor women in the drylands of Kenya through BOMA’s poverty graduation programme  +14,000 businesses established  WOMEN’S S OC IAL AND EC ONOMIC DEVELOPMENT - 25"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "26 - X X X"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": ``,
      "content": `
        <img class="abs halfScale 28-title" style="top:203px;left:332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/28-title-1.png">
        <img class="abs halfScale 28-title" style="top:398px;left:332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/28-text-1.png">
        
        <div class="28-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/en/static/_content/Cartier_Sustainable_livelihoods_V4.mp4')" style="top: 325px; left: 623px; filter: invert(1);">
          <img class="abs halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/en/static/_content/play.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax();
          pg28Anim
            .staggerFromTo(cOf("28-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("28-play"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.3")
        }

        function onPageLeave() {
          pg28Anim.stop();
          resetNumbers("28-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS Entrenched, self-perpetuating inequalities hold back the development of entire societies. For the last ten years, we’ve sought out and funded approaches that are proven to help those living in extreme poverty. With a focus on smallholder farmers, pastoral communities and small-scale entrepreneurs, our partners have helped people to access resources and become more connected to information, infrastructure and markets, as well as more productive and more resilient to changing environmental conditions. XXX - 27"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 29-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/29-title-1.png">
        <img class="abs halfScaleR 29-line" style="top:365px;left:-354px;" src="/a-decade-of-effective-philanthropy/en/static/_content/29-line-1.png">
        <img class="abs halfScaleC originBC 29-image" style="bottom:487px;left:75px;" src="/a-decade-of-effective-philanthropy/en/static/_content/29-image-1.png">
        <img class="abs halfScaleC originBC 29-image" style="bottom:616px;left:66px;" src="/a-decade-of-effective-philanthropy/en/static/_content/29-image-2.png">
        <h1 id="29-no" class="abs fancyCutMediumStretch 29-no" style="top: 258px; left: 100px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 66500, "preppend": "+", "comma": true}' ></h1>
        <img class="abs halfScale 29-text" style="top:293px;left:86px;" src="/a-decade-of-effective-philanthropy/en/static/_content/29-text-1.png">
        <h1 id="29-no" class="abs fancyCutMediumStretch 29-no" style="top: 374px; left: 95px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 45, "append": "%"}' ></h1>
        <img class="abs halfScaleC originBC 29-image" style="bottom:400px;left:-50px;" src="/a-decade-of-effective-philanthropy/en/static/_content/29-image-3.png">
        <img class="abs halfScale 29-text" style="top:424px;left:88px;" src="/a-decade-of-effective-philanthropy/en/static/_content/29-text-2.png">
        <img class="abs halfScaleC 29-image" style="top:410px;left:-190px;" src="/a-decade-of-effective-philanthropy/en/static/_content/29-image-4.png">
      `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax();
          pg29Anim
            .fromTo(cOf("29-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("29-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("29-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("29-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("29-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[0])}}, 1.75)
            .fromTo(cOf("29-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("29-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[1])}}, 2.05)
            .fromTo(cOf("29-image")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("29-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("29-image")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.65)
        }

        function onPageLeave() {
          pg29Anim.stop();
          resetNumbers("29-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "PATHWAYS OUT OF POVERTY +66,500 businesses created in sub-Saharan Africa by Village Enterprise and  45% increase in annual average income for households that graduate from Village Enterprise’s poverty graduation programme  $  $  S UB -S AH AR AN AF R I CA  28 - S U S TA I N ABL E L IVEL IHO O D S A N D ECO S YS T EMS"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 30-line" style="top:365px;left:-1068px;" src="/a-decade-of-effective-philanthropy/en/static/_content/29-line-1.png">
        <img class="abs halfScaleR 30-line" style="top:321px;left:189px;" src="/a-decade-of-effective-philanthropy/en/static/_content/30-line-2.png">
        <img class="abs halfScaleC originBC 30-image" style="bottom:135px;left:7px;" src="/a-decade-of-effective-philanthropy/en/static/_content/30-image-1.png">
        <img class="abs halfScaleC originBC 30-image" style="bottom:49px;left:309px;" src="/a-decade-of-effective-philanthropy/en/static/_content/30-image-2.png">
        <h1 id="30-no" class="abs fancyCutMediumStretch 30-no" style="top: 586px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3042; padding: 0px; margin: 0px;"  data-number='{"to": 900, "append": "%", "comma": true}' ></h1>
        <img class="abs halfScale 30-text" style="top:619px;left:109px;" src="/a-decade-of-effective-philanthropy/en/static/_content/30-text-1.png">
        <h1 id="30-no" class="abs fancyCutMediumStretch 30-no" style="top: 687px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3042; padding: 0px; margin: 0px;"  data-number='{"to": 37, "append": "%"}' ></h1>
        <img class="abs halfScale 30-text" style="top:720px;left:108px;" src="/a-decade-of-effective-philanthropy/en/static/_content/30-text-2.png">
      `,
      "script": `
        function onPageEnter() {
          pg30Anim = new TimelineMax();
          pg30Anim
            .fromTo(cOf("30-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("30-line")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("30-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("30-no")[0])}}, 1.75)
            .fromTo(cOf("30-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("30-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("30-image")[0], 0.6, {x: 30, opacity: 0}, {x: 0, opacity: 1, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("30-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("30-no")[1])}}, 2.35)
            .fromTo(cOf("30-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
        }

        function onPageLeave() {
          pg30Anim.stop();
          resetNumbers("30-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "900  AFRICA  800  700  600  500  400  900%  300  increase in savings alongside a  37%  200  $  $  Uganda  increase in income for participants of BRAC’s ultra-poor graduation programme in Bangladesh, now being adapted with a disability inclusion component in Uganda  100  0  S US TAINABLE LIVELIHOODS AND EC OS YS T EMS - 29"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 31-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/31-title-1.png">

        <img class="abs halfScaleR 31-line" style="top:197px;left:-124px;" src="/a-decade-of-effective-philanthropy/en/static/_content/31-line-1.png">
        <img class="abs halfScaleR 31-line" style="top:508px;left:-235px;" src="/a-decade-of-effective-philanthropy/en/static/_content/31-line-2.png">

        <img class="abs halfScaleC 31-image" style="bottom:381px;left:298px;" src="/a-decade-of-effective-philanthropy/en/static/_content/31-image-1.png">
        <img class="abs halfScaleC originBC 31-image" style="bottom:496px;left:25px;" src="/a-decade-of-effective-philanthropy/en/static/_content/31-image-2.png">
        <img class="abs halfScaleC originBC 31-image" style="bottom:49px;left:33px;" src="/a-decade-of-effective-philanthropy/en/static/_content/31-image-3.png">
        <img class="abs halfScaleC 31-image" style="bottom:-157px;left:359px;" src="/a-decade-of-effective-philanthropy/en/static/_content/31-image-4.png">

        <img class="abs halfScale 31-text" style="top:237px;left:215px;" src="/a-decade-of-effective-philanthropy/en/static/_content/31-text-1.png">
        <img class="abs halfScale 31-text" style="top:328px;left:510px;" src="/a-decade-of-effective-philanthropy/en/static/_content/31-text-2.png">
        <img class="abs halfScale 31-text" style="top:667px;left:220px;" src="/a-decade-of-effective-philanthropy/en/static/_content/31-text-3.png">

        <h1 id="31-no" class="abs fancyCutMediumStretch 31-no" style="top: 202px; left: 224px; font-size: 1.7em; font-weight: 300; color: #1a3142; padding: 0px; margin: 0px;"  data-number='{"to": 221, "append": "%", "comma": true}' ></h1>
        <h1 id="31-no" class="abs fancyCutMediumStretch 31-no" style="top: 632px; left: 227px; font-size: 1.7em; font-weight: 300; color: #1a3142; padding: 0px; margin: 0px;"  data-number='{"to": 20, "append": "–"}' ></h1>
        <h1 id="31-no" class="abs fancyCutMediumStretch 31-no" style="top: 632px; left: 283px; font-size: 1.7em; font-weight: 300; color: #1a3142; padding: 0px; margin: 0px;"  data-number='{"to": 25, "append": "%"}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg31Anim = new TimelineMax();
          pg31Anim
            .fromTo(cOf("31-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("31-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("31-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("31-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("31-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("31-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("31-no")[0])}}, 1.9)
            .fromTo(cOf("31-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("31-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("31-image")[2], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("31-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("31-no")[1])}}, 2.65)
            .fromTo(cOf("31-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("31-no")[2])}}, 2.8)
            .fromTo(cOf("31-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("31-image")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.25)
        }

        function onPageLeave() {
          pg31Anim.stop();
          resetNumbers("31-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "STRONGER SMALLHOLDER FARMERS 221%  increase in food grown in 2021 by farmers supported by myAgro  0%  Se n e g a l  100  $  100 50$  5  Pe ru  35 30 25 20 15 10 5 0  20−25%  average yearly growth for small agricultural enterprises supported by Root Capital, resulting in improved livelihoods for the thousands of smallholder farmers that supply them  30 - S U S TA I N ABL E L IVEL IHO O D S A N D ECO S YS T EMS  $  $  earning an additional $255 per farmer, a 46% increase on the average farmer’s income"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 32-line" style="top:197px;left:-839px;" src="/a-decade-of-effective-philanthropy/en/static/_content/31-line-1.png">
        <img class="abs halfScaleR 32-line" style="top:179px;left:204px;" src="/a-decade-of-effective-philanthropy/en/static/_content/32-line-2.png">
        
        <img class="abs halfScaleC 32-image" style="bottom:239px;left:-7px;" src="/a-decade-of-effective-philanthropy/en/static/_content/32-image-1.png">
        <img class="abs halfScaleC originBC 32-image" style="bottom:45px;left:194px;" src="/a-decade-of-effective-philanthropy/en/static/_content/32-image-2.png">
        <img class="abs halfScaleC originBC 32-image" style="bottom:39px;left:375px;" src="/a-decade-of-effective-philanthropy/en/static/_content/32-image-3.png">
        <img class="abs halfScaleC 32-image" style="bottom:27px;left:472px;" src="/a-decade-of-effective-philanthropy/en/static/_content/32-image-4.png">

        <img class="abs halfScaleR 32-line" style="top:294px;left:-752px;transform:scale(0.225)" src="/a-decade-of-effective-philanthropy/en/static/_content/32-line-3.png">

        <img class="abs halfScale 32-text" style="top:661px;left:94px;" src="/a-decade-of-effective-philanthropy/en/static/_content/32-text-1.png">
        <img class="abs halfScale 32-text" style="top:773px;left:94px;" src="/a-decade-of-effective-philanthropy/en/static/_content/32-text-2.png">
        <img class="abs halfScale 32-text" style="top:558px;left:429px;" src="/a-decade-of-effective-philanthropy/en/static/_content/32-text-3.png">

        <h1 id="32-no" class="abs fancyCutMediumStretch 32-no" style="top: 524px; left: 444px; font-size: 1.7em; font-weight: 300; color: #1a3242; padding: 0px; margin: 0px;"  data-number='{"to": 250000, "comma": true}' ></h1>
        <h1 id="32-no" class="abs fancyCutMediumStretch 32-no" style="top: 626px; left: 109px; font-size: 1.7em; font-weight: 300; color: #1a3242; padding: 0px; margin: 0px;"  data-number='{"to": 631800, "comma": true}' ></h1>
        <h1 id="32-no" class="abs fancyCutMediumStretch 32-no" style="top: 769px; left: 98px; font-size: 1em; font-weight: 300; color: #1a3242; padding: 0px; margin: 0px;"  data-number='{"to": 47, "append": "%"}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg32Anim = new TimelineMax();
          pg32Anim
            .fromTo(cOf("32-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("32-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("32-line")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("32-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[0])}}, 1.75)
            .fromTo(cOf("32-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("32-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("32-image")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("32-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("32-line")[2], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("32-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[1])}}, 2.8)
            .fromTo(cOf("32-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("32-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.1)
            .fromTo(cOf("32-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.25)
            .fromTo(cOf("32-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[2])}}, 2.8)
        }

        function onPageLeave() {
          pg32Anim.stop();
          resetNumbers("32-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "M y a nm a r  250,000  farm families served per year by Proximity Designs, resulting in a $300 net annual gain in income per farmer  R w an d a  631,800  Rwandan farmers increased their income by $115 on average with support from One Acre Fund 100  47% increase in income on supported activities  10 5  100 100 100  $  $ $ $  $ $ S US TAINABLE LIVELIHOODS AND EC OS YS T EMS - 31"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 33-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/33-title-1.png">

        <img class="abs halfScaleC 33-image" style="bottom:166px;left:-193px;" src="/a-decade-of-effective-philanthropy/en/static/_content/33-image-1.png">
        <img class="abs halfScaleR 33-line" style="top:422px;left:-244px;" src="/a-decade-of-effective-philanthropy/en/static/_content/33-line-1.png">

        <img class="abs halfScaleC  33-image" style="bottom:-82px;left:-72px;" src="/a-decade-of-effective-philanthropy/en/static/_content/33-image-2.png">
        <img class="abs halfScaleC originBC 33-image" style="bottom:109px;left:250px;" src="/a-decade-of-effective-philanthropy/en/static/_content/33-image-3.png">

        <img class="abs halfScale 33-text" style="top:720px;left:382px;" src="/a-decade-of-effective-philanthropy/en/static/_content/33-text-1.png">

        <h1 id="33-no" class="abs fancyCutMediumStretch 33-no" style="top: 667px; left: 390px; font-size: 1.9em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 23, "append": "%", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg33Anim = new TimelineMax();
          pg33Anim
            .fromTo(cOf("33-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("33-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("33-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("33-image")[1], 0.6, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("33-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("33-no")[0])}}, 1.9)
            .fromTo(cOf("33-image")[2], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("33-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
        }

        function onPageLeave() {
          pg33Anim.stop();
          resetNumbers("33-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "EQUIPPED TO THRIVE  Zambia  23% income increase for Zambian dairy farmers equipped with a Buffalo Bicycle by World Bicycle Relief 32 - S U S TA I N ABL E L IVEL IHO O D S A N D ECO S YS T EMS  $  $"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 34-line" style="top:422px;left:-958px;" src="/a-decade-of-effective-philanthropy/en/static/_content/33-line-1.png">
        <img class="abs halfScaleR 34-line" style="top:187px;left:276px;" src="/a-decade-of-effective-philanthropy/en/static/_content/34-line-2.png">

        <img class="abs halfScaleC originBC 34-image" style="bottom:49px;left:159px;" src="/a-decade-of-effective-philanthropy/en/static/_content/34-image-1.png">
        <img class="abs halfScaleC 34-image" style="bottom:-114px;left:170px;" src="/a-decade-of-effective-philanthropy/en/static/_content/34-image-2.png">


        <img class="abs halfScale 34-text" style="top:572px;left:70px;" src="/a-decade-of-effective-philanthropy/en/static/_content/34-text-1.png">
        <img class="abs halfScale 34-text" style="top:702px;left:70px;" src="/a-decade-of-effective-philanthropy/en/static/_content/34-text-2.png">

        <h1 id="34-no" class="abs fancyCutMediumStretch 34-no" style="top: 538px; left: 78px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 1.9, "append": "M", "decimals": 1}' ></h1>
        <h1 id="34-no" class="abs fancyCutMediumStretch 34-no" style="top: 667px; left: 77px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 22, "append": "–", "comma": true}' ></h1>
        <h1 id="34-no" class="abs fancyCutMediumStretch 34-no" style="top: 667px; left: 140px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 32, "append": "%", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax();
          pg34Anim
            .fromTo(cOf("34-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("34-line")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("34-image")[1], 0.6, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("34-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("34-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("34-no")[0])}}, 2.35)
            .fromTo(cOf("34-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("34-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("34-no")[1])}}, 2.65)
            .fromTo(cOf("34-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("34-no")[2])}}, 2.8)
            .fromTo(cOf("34-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
        }

        function onPageLeave() {
          pg34Anim.stop();
          resetNumbers("33-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "B a ng l a d e s h  1.9M  low-income Bangladeshis provided with reading glasses by VisionSpring since 2006  22−32%  increase in productivity demonstrated in India by people provided with glasses by VisionSpring  35 30 25 20 15 10 5 0  S US TAINABLE LIVELIHOODS AND EC OS YS T EMS - 33"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "34 - X X X"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": ``,
      "content": `
        <img class="abs halfScale 36-title" style="top:453px;left:332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/36-title-1.png">
        <img class="abs halfScale 36-title" style="top:560px;left:332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/36-text-1.png">
        <div class="36-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/en/static/_content/Cartier_Philanthropy_Emergency_Response-V12_W_SUBS.mp4')" style="top: 486px; left: 563px; filter: invert(1);">
          <img class="abs halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/en/static/_content/play.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg36Anim = new TimelineMax();
          pg36Anim
            .staggerFromTo(cOf("36-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("36-play"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.3")
        }

        function onPageLeave() {
          pg36Anim.stop();
          resetNumbers("36-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "EMERGENCY RESPONSE Effective and timely emergency aid can save lives, relieve suffering and protect livelihoods. Over the past decade, our partners have responded to some of the world’s most severe crises, committed to restoring the dignity and reducing the vulnerability of those in greatest need, who often suffer unheard and unseen. XXX - 35"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 37-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/37-title-1.png">

        <img class="abs halfScaleC 37-image" style="bottom:303px;left:-36px;" src="/a-decade-of-effective-philanthropy/en/static/_content/37-image-1.png">
        
        <img class="abs halfScaleR 37-line" style="top:638px;left:-441px;" src="/a-decade-of-effective-philanthropy/en/static/_content/37-line-1.png">
        <img class="abs halfScaleR 37-line" style="top:436px;left:-621px;" src="/a-decade-of-effective-philanthropy/en/static/_content/37-line-2.png">

        <img class="abs halfScale 37-text" style="top:497px;left:115px;" src="/a-decade-of-effective-philanthropy/en/static/_content/37-text-1.png">
        <img class="abs halfScale 37-text" style="top:374px;left:320px;" src="/a-decade-of-effective-philanthropy/en/static/_content/37-text-2.png">

        <h1 id="37-no" class="abs fancyCutMediumStretch 37-no" style="top: 465px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 8, "append": "", "comma": true}' ></h1>
        <h1 id="37-no" class="abs fancyCutMediumStretch 37-no" style="top: 342px; left: 330px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 34500, "preppend": "+", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg37Anim = new TimelineMax();
          pg37Anim
            .fromTo(cOf("37-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("37-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("37-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("37-no")[0])}}, 1.6)
            .fromTo(cOf("37-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("37-no")[1])}}, 1.9)
            .fromTo(cOf("37-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("37-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("37-line")[0], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("37-line")[1], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
        }

        function onPageLeave() {
          pg37Anim.stop();
          resetNumbers("37-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "MIGRATION AND DISPLACEMENT  +34,500  survivors rescued in Central Mediterranean by SOS Méditerranée since 2016  8  refugee camps closed in Haiti between 2013 and 2017 by CARE, who supported people to find new adequate places to live  2012  2013  36 - E ME R GE N CY R ESP O N SE  2014  2015  2016  2017"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleC 38-image" style="bottom:452px;left:-15px;" src="/a-decade-of-effective-philanthropy/en/static/_content/38-image-1.png">
        <img class="abs halfScaleC 38-image" style="bottom:527px;left:306px;" src="/a-decade-of-effective-philanthropy/en/static/_content/38-image-2.png">
        <img class="abs halfScaleC 38-image" style="bottom:194px;left:270px;" src="/a-decade-of-effective-philanthropy/en/static/_content/38-image-3.png">
        <img class="abs halfScaleC 38-image" style="bottom:425px;left:422px;" src="/a-decade-of-effective-philanthropy/en/static/_content/38-image-4.png">
        <img class="abs halfScaleC 38-image" style="bottom:334px;left:452px;" src="/a-decade-of-effective-philanthropy/en/static/_content/38-image-5.png">
        
        <img class="abs halfScaleR 38-line" style="top:436px;left:-1335px;" src="/a-decade-of-effective-philanthropy/en/static/_content/37-line-2.png">
        <img class="abs halfScaleR 38-line" style="top:177px;left:-150px;" src="/a-decade-of-effective-philanthropy/en/static/_content/38-line-2.png">
        <img class="abs halfScaleR 38-line" style="top:313px;left:231px;" src="/a-decade-of-effective-philanthropy/en/static/_content/38-line-3.png">
        <img class="abs halfScaleR 38-line" style="top:619px;left:423px;" src="/a-decade-of-effective-philanthropy/en/static/_content/38-line-4.png">

        <img class="abs halfScale 38-text" style="top:389px;left:79px;" src="/a-decade-of-effective-philanthropy/en/static/_content/38-text-1.png">
        <img class="abs halfScale 38-text" style="top:340px;left:336px;" src="/a-decade-of-effective-philanthropy/en/static/_content/38-text-2.png">
        <img class="abs halfScale 38-text" style="top:519px;left:496px;" src="/a-decade-of-effective-philanthropy/en/static/_content/38-text-3.png">

        <h1 id="38-no" class="abs fancyCutMediumStretch 38-no" style="top: 356px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 340000, "append": "", "comma": true}' ></h1>
        <h1 id="38-no" class="abs fancyCutMediumStretch 38-no" style="top: 306px; left: 347px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 10000, "preppend": "+", "comma": true}' ></h1>
        <h1 id="38-no" class="abs fancyCutMediumStretch 38-no" style="top: 486px; left: 509px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 200000, "append": "", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg38Anim = new TimelineMax();
          pg38Anim
            .fromTo(cOf("38-line")[0], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("38-line")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("38-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("38-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("38-no")[0])}}, 2.5)
            .fromTo(cOf("38-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("38-line")[2], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("38-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("38-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("38-no")[1])}}, 2.8)
            .fromTo(cOf("38-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("38-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.1)
            .fromTo(cOf("38-line")[3], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.8)
            .fromTo(cOf("38-image")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("38-image")[4], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.1)
            .fromTo(cOf("38-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("38-no")[2])}}, 3.25)
            .fromTo(cOf("38-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.4)
        }

        function onPageLeave() {
          pg38Anim.stop();
          resetNumbers("38-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "+10,000 Afghans supported to resettle in the US by the International Rescue Committee  340,000  Rohingya refugees provided with quality health services in Cox’s Bazar by Médecins Sans Frontières in 2018 and BRAC in 2019 and 2020  2018  2019  200,000 individuals being assisted, outside and inside Ukraine, by Medair  2020  2021  2022 EMERG ENC Y RES PONS E - 37"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 39-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/39-title-1.png">
        <img class="abs halfScale 39-title" style="top:552px;left:242px;" src="/a-decade-of-effective-philanthropy/en/static/_content/39-text-1.png">
        <img class="abs halfScale 39-title" style="top:717px;left:406px;" src="/a-decade-of-effective-philanthropy/en/static/_content/39-title-2.png">

        <img class="abs halfScaleC 39-image" style="bottom:359px;left:203px;" src="/a-decade-of-effective-philanthropy/en/static/_content/39-image-1.png">
        <img class="abs halfScaleC 39-image" style="bottom:254px;left:35px;" src="/a-decade-of-effective-philanthropy/en/static/_content/39-image-2.png">
        <img class="abs halfScaleC 39-image" style="bottom:103px;left:144px;" src="/a-decade-of-effective-philanthropy/en/static/_content/39-image-3.png">
        
        <h1 id="39-no" class="abs fancyCutMediumStretch 39-no" style="top: 485px; left: 260px; font-size: 3.6em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 4.3, "append": "M", "decimals": 1}' ></h1>
        <h1 id="39-no" class="abs fancyCutMediumStretch 39-no" style="top: 648px; left: 412px; font-size: 3.6em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 21, "preppend": "", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg39Anim = new TimelineMax();
          pg39Anim
            .fromTo(cOf("39-title")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .staggerFromTo(cOf("39-image"), 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 0.3, 1.3)
            .fromTo(cOf("39-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("39-no")[0])}}, 1.75)
            .fromTo(cOf("39-title")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("39-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("39-no")[1])}}, 2.05)
            .fromTo(cOf("39-title")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
        }

        function onPageLeave() {
          pg39Anim.stop();
          resetNumbers("39-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "CORONAVIRUS PANDEMIC 2020-2022  4.3M  S W I S S F RA NCS  21  COUNTRI E S  38 - E ME R GE N CY R ESP O N SE"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 40-title" style="top:698px;left:244px;" src="/a-decade-of-effective-philanthropy/en/static/_content/40-text-1.png">

        <img class="abs halfScaleC 40-image" style="bottom:515px;left:-27px;" src="/a-decade-of-effective-philanthropy/en/static/_content/40-image-1.png">
        <img class="abs halfScaleC 40-image" style="bottom:457px;left:172px;" src="/a-decade-of-effective-philanthropy/en/static/_content/40-image-2.png">
        <img class="abs halfScaleC 40-image" style="bottom:277px;left:-7px;" src="/a-decade-of-effective-philanthropy/en/static/_content/40-image-3.png">
        <img class="abs halfScaleC 40-image" style="bottom:233px;left:194px;" src="/a-decade-of-effective-philanthropy/en/static/_content/40-image-4.png">
        <img class="abs halfScaleC 40-image" style="bottom:93px;left:39px;" src="/a-decade-of-effective-philanthropy/en/static/_content/40-image-5.png">
        
        <h1 id="40-no" class="abs fancyCutMediumStretch 40-no" style="top: 628px; left: 252px; font-size: 3.6em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 20, "preppend": "", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg40Anim = new TimelineMax();
          pg40Anim
            .staggerFromTo(cOf("40-image"), 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 0.3, 1.3)
            .fromTo(cOf("40-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("40-no")[0])}}, 2.65)
            .fromTo(cOf("40-title")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)
        }

        function onPageLeave() {
          pg40Anim.stop();
          resetNumbers("40-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "20  O R GA NI S ATI ONS  EMERG ENC Y RES PONS E - 39"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `
        <div class="abs" style="top: 478px; left: 555px; width: 25px; height: 24px; background: white;"></div>

        <img class="abs halfScale 41-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/41-title-1.png">

        <img class="abs halfScaleC 41-image" style="bottom:576px;left:397px;" src="/a-decade-of-effective-philanthropy/en/static/_content/41-image-1.png">
        <img class="abs halfScaleC 41-image" style="bottom:35px;left:364px;" src="/a-decade-of-effective-philanthropy/en/static/_content/41-image-2.png">
        
        <img class="abs halfScaleR 41-line" style="top:373px;left:-13px;" src="/a-decade-of-effective-philanthropy/en/static/_content/41-line-1.png">
        <img class="abs halfScaleR 41-line" style="top:316px;left:98px;" src="/a-decade-of-effective-philanthropy/en/static/_content/41-line-2.png">

        <img class="abs halfScale 41-text" style="top:404px;left:86px;" src="/a-decade-of-effective-philanthropy/en/static/_content/41-text-1.png">

        <h1 id="41-no" class="abs fancyCutMediumStretch 41-no" style="top: 369px; left: 103px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 200000, "comma": true}' ></h1>
        <h1 id="41-no" class="abs fancyCutMediumStretch 41-no" style="top: 272px; left: 426px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 2.8, "append": "M", "decimals": 1}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg41Anim = new TimelineMax();
          pg41Anim
            .fromTo(cOf("41-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("41-line")[0], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("41-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("41-no")[0])}}, 1.45)
            .fromTo(cOf("41-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("41-line")[1], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("41-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("41-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("41-no")[1])}}, 2.2)
            .fromTo(cOf("41-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.35)
        }

        function onPageLeave() {
          pg41Anim.stop();
          resetNumbers("41-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "NATURAL DISASTERS  2.8M 200,000  Filipinos assisted with clean water and safe sanitation by Action Against Hunger after Typhoon Haiyan  2012  2013  40 - E ME R GE N CY R ESP O N SE  Nepalese people supported with food by the International Federation of the Red Cross after the 2015 earthquake  2014  2015  2016  2017"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleC 42-image" style="bottom:520px;left:9px;" src="/a-decade-of-effective-philanthropy/en/static/_content/42-image-1.png">
        <img class="abs halfScaleC 42-image" style="bottom:395px;left:316px;" src="/a-decade-of-effective-philanthropy/en/static/_content/42-image-2.png">
        
        <img class="abs halfScaleR 42-line" style="top:297px;left:-195px;" src="/a-decade-of-effective-philanthropy/en/static/_content/42-line-1.png">
        <img class="abs halfScaleR 42-line" style="top:150px;left:228px;" src="/a-decade-of-effective-philanthropy/en/static/_content/42-line-2.png">
        <img class="abs halfScaleR 42-line" style="top:337px;left:359px;" src="/a-decade-of-effective-philanthropy/en/static/_content/42-line-3.png">

        <img class="abs halfScale 42-text" style="top:329px;left:118px;" src="/a-decade-of-effective-philanthropy/en/static/_content/42-text-1.png">
        <img class="abs halfScale 42-text" style="top:498px;left:118px;" src="/a-decade-of-effective-philanthropy/en/static/_content/42-text-2.png">
        <img class="abs halfScale 42-text" style="top:187px;left:334px;" src="/a-decade-of-effective-philanthropy/en/static/_content/42-text-3.png">
        <img class="abs halfScale 42-text" style="top:456px;left:407px;" src="/a-decade-of-effective-philanthropy/en/static/_content/42-text-4.png">
        <img class="abs halfScale 42-text" style="top:604px;left:408px;" src="/a-decade-of-effective-philanthropy/en/static/_content/42-text-5.png">

        <h1 id="42-no" class="abs fancyCutMediumStretch 42-no" style="top: 295px; left: 132px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 20900, "comma": true}' ></h1>
        <h1 id="42-no" class="abs fancyCutMediumStretch 42-no" style="top: 465px; left: 132px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 127500, "comma": true}' ></h1>
        <h1 id="42-no" class="abs fancyCutMediumStretch 42-no" style="top: 152px; left: 348px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 50000, "comma": true}' ></h1>
        <h1 id="42-no" class="abs fancyCutMediumStretch 42-no" style="top: 422px; left: 418px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 10000, "comma": true}' ></h1>
        <h1 id="42-no" class="abs fancyCutMediumStretch 42-no" style="top: 569px; left: 418px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 2000, "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg42Anim = new TimelineMax();
          pg42Anim
            .fromTo(cOf("42-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("42-line")[0], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("42-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("42-no")[0])}}, 2.65)
            .fromTo(cOf("42-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)
            .fromTo(cOf("42-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("42-no")[1])}}, 2.95)
            .fromTo(cOf("42-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)
            .fromTo(cOf("42-line")[1], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 3.4)
            .fromTo(cOf("42-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.55)
            .fromTo(cOf("42-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("42-no")[2])}}, 3.7)
            .fromTo(cOf("42-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.85)
            .fromTo(cOf("42-line")[2], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 4.15)
            .fromTo(cOf("42-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 4.3)
            .fromTo(cOf("42-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("42-no")[3])}}, 4.45)
            .fromTo(cOf("42-text")[3], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 4.6)
            .fromTo(cOf("42-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("42-no")[4])}}, 4.75)
            .fromTo(cOf("42-text")[4], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 4.9)
        }

        function onPageLeave() {
          pg42Anim.stop();
          resetNumbers("42-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "50,000  Bangladeshi families assisted by BRAC with relief and recovery support after unprecedented monsoon floods  20,900  children treated with a outpatient feeding programme by Médecins Sans Frontières in Magaria, Niger  10,000  people assisted by Medair with emergency food relief in Belhoa District, Madagascar  127,500  children under five screened for malnutrition  2,000  children under five screened for malnutrition  = 100 children under five  2018  2019  2020  2021  2022 EMERG ENC Y RES PONS E - 41"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "42 - A XX CCE X S S TO B A SIC SER VICES"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg44.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 44-title" style="top:172px;left:332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/44-title-1.png">
        <img class="abs halfScale 44-title" style="top:397px;left:332px;" src="/a-decade-of-effective-philanthropy/en/static/_content/44-title-2.png">
        <img class="abs halfScale 44-title" style="top:503px;left:356px;" src="/a-decade-of-effective-philanthropy/en/static/_content/44-text-1.png">
        <img class="abs halfScale 44-title" style="top:555px;left:356px;" src="/a-decade-of-effective-philanthropy/en/static/_content/44-text-2.png">
        <img class="abs halfScale 44-title" style="top:626px;left:356px;" src="/a-decade-of-effective-philanthropy/en/static/_content/44-text-3.png">
        <img class="abs halfScale 44-title" style="top:718px;left:356px;" src="/a-decade-of-effective-philanthropy/en/static/_content/44-text-4.png">
        <img class="abs halfScale 44-title" style="top:789px;left:356px;" src="/a-decade-of-effective-philanthropy/en/static/_content/44-text-5.png">

        <div class="contentLinkNone" onclick="Publish.goToPage(44);" style="top: 498px; left: 351px; width: 305px; height: 24px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(46);" style="top: 551px; left: 351px; width: 305px; height: 41px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(48);" style="top: 621px; left: 351px; width: 305px; height: 61px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(50);" style="top: 713px; left: 351px; width: 305px; height: 41px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(52);" style="top: 784px; left: 351px; width: 305px; height: 41px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg44Anim = new TimelineMax();
          pg44Anim
            .staggerFromTo(cOf("44-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg44Anim.stop();
          resetNumbers("43-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "THE FIVE LESSONS WE’VE LEARNED IN A DECADE OF GRANT-MAKING 1.  FUND IMPACT 2. T  HINK LONG-TERM AND UNRESTRICTED FUNDING 3. INNOVATION IS GREAT, BUT SCALING PROVEN SOLUTIONS IS EVEN BETTER 4. F  IND THE RIGHT BALANCE IN THE POWER DYNAMIC 5. C  OMMIT TO RESULTS AND HOLD YOURSELF ACCOUNTABLE XXX - 43"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 43,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg45.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 45-title" style="top:681px;left:84px;" src="/a-decade-of-effective-philanthropy/en/static/_content/45-title-1.png">
        <img class="abs halfScale 45-title" style="top:738px;left:85px;" src="/a-decade-of-effective-philanthropy/en/static/_content/45-text-1.png">
        <img class="abs halfScale 45-title" style="top:777px;left:85px;" src="/a-decade-of-effective-philanthropy/en/static/_content/45-text-2.png">

        <h1 id="45-no" class="abs fancyCutBold 45-no" style="top: 378px; left: 539px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 40, "append": "%"}' ></h1>
        <h1 id="45-no" class="abs fancyCutBold 45-no" style="top: 412px; left: 553px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 0.8, "append": "%", "decimals": 1}' ></h1>

        <div class="contentLinkNone abs" style="top: 676px; left: 79px; width: 565px; height: 151px;" onclick="Publish.openArticle(2)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg45Anim = new TimelineMax();
          pg45Anim
            .staggerFromTo(cOf("45-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("45-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("45-no")[0])}}, 1.3)
            .fromTo(cOf("45-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("45-no")[1])}}, 1.6)
        }

        function onPageLeave() {
          pg45Anim.stop();
          resetNumbers("45-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "mother-to-child HIV transmission rate reduction from  40% to 0.8%  1. FUND IMPACT There’s too much to do in the world today – and too much urgency to support people living in poverty – to waste any money, time or energy on development programmes or interventions that don’t work. Our number one responsibility as funders is to make sure that every dollar we spend helps to create positive, concrete, verifiable change in the lives of the people we strive to serve. For that to happen, we need to support proven solutions, backed by data-driven evidence, that will lead to impactful results. 44 - T HE F I V E L ESSO N S W E L EA R N ED"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 44,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg46.jpg",
      "zoom": null,
      "content": `
        <h1 id="46-no" class="abs fancyCutBold 46-no" style="top: 211px; left: 550px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 75, "append": "%"}' ></h1>
        <div class="contentLinkNone abs" style="    top: 446px; left: 62px; width: 569px; height: 381px;" onclick="Publish.openArticle(2)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg46Anim = new TimelineMax();
          pg46Anim
            .fromTo(cOf("46-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("46-no")[0])}}, 1.3)
        }

        function onPageLeave() {
          pg46Anim.stop();
          resetNumbers("46-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "75%  of students still in school after six years  mothers2mothers  The Luminos Fund  mothers2mothers (m2m) employs women living with HIV to help other women and their families access essential services and medical care. Preventing HIV infection and related diseases is a key focus of the programme. Since 2017, our funding has allowed m2m to scale up its integrated health services in Uganda to prevent HIV-positive pregnant women from transmitting the virus to their baby and maintaining the health of women and children.  The Luminos Fund’s Second Chance accelerated learning programme has already enabled over 152,000 African children who never attended school or were forced to drop out because of poverty, conflict or discrimination to return to lessons. Since 2018, we’ve been supporting the rapid expansion of the programme across the remote Afar and Oromia regions of Ethiopia.  Country: Uganda Funded since 2017  In the past 20 years, m2m’s work has resulted in the virtual elimination of mother-to-child transmission of HIV among the women they serve. Among m2m’s clients in east and southern Africa, the mother-to-child HIV transmission rate has dropped from 40% to 0.8% and child mortality has reduced to two deaths per 1,000 live births.  Country: Ethiopia Funded since 2018  Between 91% and 97% of the 26,850 children enrolled in Second Chance classes between 2018 and 2021 successfully transitioned to state schools to continue their education. Nine thousand more children were enrolled in government-run versions of the Second Chance programme. Seventy-five per cent of Second Chance students are still attending school after six years. T HE FIVE LES S ONS WE LEARNED - 45"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 45,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg47.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 47-title" style="top:614px;left:86px;" src="/a-decade-of-effective-philanthropy/en/static/_content/47-title-1.png">
        <img class="abs halfScale 47-title" style="top:713px;left:86px;transform:scale(0.525)" src="/a-decade-of-effective-philanthropy/en/static/_content/47-text-1.png">
        <div class="contentLinkNone abs" style="top: 610px; left: 79px; width: 565px; height: 218px;" onclick="Publish.openArticle(3)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg47Anim = new TimelineMax();
          pg47Anim
            .staggerFromTo(cOf("47-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg47Anim.stop();
          resetNumbers("47-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "2. THINK LONG-TERM AND UNRESTRICTED FUNDING We work on complex, multi-faceted issues and, as such, we don’t expect to solve them overnight. We’re in it for the long term. A focus on two-to-three-year projects often just leads to a tick-box approach. Instead, we’ve chosen to commit to strong alliances and long-term funding, supporting our partner organisations to keep growing, deepening their impact and expanding their geographical scope of operations. Providing unrestricted funding, which non-profits can spend any way they believe is appropriate, is perhaps the single most transformational move we can make to truly help our partners deliver on their missions. 46 - T HE F I V E L ESSO N S W E L EA R N ED"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 46,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg48.jpg",
      "zoom": null,
      "content": `
        <h1 id="48-no" class="abs fancyCutBold 48-no" style="top: 301px; left: 563px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 2.8, "preppend": "+", "append": "M", "decimals": 1}' ></h1>
        <div class="contentLinkNone abs" style="    top: 431px; left: 62px; width: 569px; height: 396px;" onclick="Publish.openArticle(3)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg48Anim = new TimelineMax();
          pg48Anim
            .fromTo(cOf("48-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("48-no")[0])}}, 1.3)
        }

        function onPageLeave() {
          pg48Anim.stop();
          resetNumbers("48-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "+2.8M girls supported worldwide  Educate Girls  Room to Read  Educate Girls tackles the gender and literacy gap in rural India’s education system, bringing out-ofschool girls back to mainstream education. From an initial pilot project of 50 schools in 2007, it currently operates in over 20,000 villages in Rajasthan, Madhya Pradesh and Uttar Pradesh.  Room to Read seeks to transform the lives of millions of children in low-income communities by focusing on literacy and gender equality in education. Working with local communities, partner organisations and governments, the organisation develops literacy skills and instils the habit of reading among primary school children.  Country: India Funded since 2014  Educate Girls has consistently achieved impressive enrolment, retention and learning outcomes over the years. Household visits and community outreach are at the heart of the organisation’s success. Educate Girls also taps into government resources to improve schools’ infrastructure, governance and teaching. As part of our long-term alliance with Educate Girls, we’ve funded their unique approach since 2014 and contributed to the enrolment of over 1.1 million girls worldwide. We’re now supporting the organisation’s bold goal of scaling to 1.5 million by 2024.  Countries: Bangladesh, Cambodia, global Funded since 2019  We’ve been supporting Room to Read’s Girls’ Education programme in Bangladesh and Cambodia since 2019, enabling adolescent girls to learn and practise life skills through classes, workshops and extracurricular activities, with the aim of encouraging them to pursue their education and create the future they want. Since July 2022, we’ve been funding the organisation unrestrictedly.  T HE FIVE LES S ONS WE LEARNED - 47"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 47,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg49.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 49-title" style="top:602px;left:84px;" src="/a-decade-of-effective-philanthropy/en/static/_content/49-title-1.png">
        <img class="abs halfScale 49-title" style="top:743px;left:85px;" src="/a-decade-of-effective-philanthropy/en/static/_content/49-text-1.png">

        <h1 id="49-no" class="abs fancyCutBold 49-no" style="top: 387px; left: 509px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 160000, "comma": true}' ></h1>
        <div class="contentLinkNone abs" style="top: 598px; left: 79px; width: 565px; height: 228px;" onclick="Publish.openArticle(4)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg49Anim = new TimelineMax();
          pg49Anim
            .staggerFromTo(cOf("49-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("49-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("49-no")[0])}}, 1.3)
        }

        function onPageLeave() {
          pg49Anim.stop();
          resetNumbers("49-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "160,000 women with depression treated in Uganda and Zambia  3. INNOVATION IS GREAT, BUT SCALING PROVEN SOLUTIONS IS EVEN BETTER Given the urgency and intensity of today’s social problems, if the whole philanthropic community is seduced by the excitement of innovation and focuses solely on that, then we’ll never be able to take the proven solutions that already exist to scale. In other words, we don’t need another million innovations. We just need one that works, scaled a million times so that its impact grows to match the level of need. 48 - T HE F I V E L ESSO N S W E L EA R N ED"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 48,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg50.jpg",
      "zoom": null,
      "content": `
        <h1 id="50-no" class="abs fancyCutBold 50-no" style="top: 150px; left: 279px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 38, "append": "%"}' ></h1>
        <div class="contentLinkNone abs" style="    top: 481px; left: 62px; width: 569px; height: 346px;" onclick="Publish.openArticle(4)"></div>
        <div class="contentLinkNone abs" style="top: 334px; left: 62px; width: 289px; height: 157px;" onclick="Publish.openArticle(4)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg50Anim = new TimelineMax();
          pg50Anim
            .fromTo(cOf("50-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("50-no")[0])}}, 1.3)
        }

        function onPageLeave() {
          pg50Anim.stop();
          resetNumbers("50-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "38%  reduction in student morbidity  StrongMinds  Countries: Uganda, Zambia Funded since 2018  The WHO endorses group interpersonal psychotherapy as a front-line mental health intervention for vulnerable populations. StrongMinds is the only organisation scaling this cost-effective solution to help end depression in Africa. StrongMinds trains and supervises community workers to become mental health facilitators and lead group therapy sessions. These sessions are designed to support women with depression in poor communities, where the prevalence of depression is as high as 25%. Groups of ten-15 women meet for weekly 90-minute sessions where they learn how to identify the triggers of depression, and share strategies to overcome their symptoms and build long-term resilience. StrongMinds’ model enables women who have completed their group therapy sessions to be trained to lead their own peer therapy groups, multiplying the organisation’s impact. Since 2018, we have been supporting StrongMinds to replicate the model it developed in Uganda in Zambia. StrongMinds is now poised to become the Zambian Ministry of Health’s technical advisor on mental health.  Healthy Learners Country: Zambia Funded since 2019  Healthy Learners works to improve the health of children aged over five years through a school-based community health programme. The organisation trains teachers to recognise symptoms of common diseases in students and provide them with rapid treatment or refer them to health centres. This ensures that sick children are identified and treated quickly, reducing their morbidity and the duration of their absence from school. Since we started supporting it in 2019, Healthy Learners has systematised this model and strengthened its collaboration with the Zambian government’s Ministries of Health and Education to scale it as a national school health programme. T HE FIVE LES S ONS WE LEARNED - 49"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 49,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg51.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 51-title" style="top:596px;left:86px;" src="/a-decade-of-effective-philanthropy/en/static/_content/51-title-1.png">
        <img class="abs halfScale 51-title" style="top:696px;left:86px;" src="/a-decade-of-effective-philanthropy/en/static/_content/51-text-1.png">
        <div class="contentLinkNone abs" style="    top: 591px; left: 79px; width: 575px; height: 238px;" onclick="Publish.openArticle(5)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg51Anim = new TimelineMax();
          pg51Anim
            .staggerFromTo(cOf("51-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg51Anim.stop();
          resetNumbers("51-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "4. FIND THE RIGHT BALANCE IN THE POWER DYNAMIC When it comes to shifting and improving giving practices, the onus is on funders. Power dynamics dictate that funders must be the ones to reimagine their relationship with grantees, starting by recognising the inherent power imbalance that can inhibit honest and fruitful collaboration. Our partners need us to be flexible, pragmatic, open to learning about their needs and challenges, and ready to leverage their work publicly. Most of all, though, they need us to trust them. Over the years, we’ve intentionally created time and space for conversations where our partners can feel free to express doubts, question requests and present strategy shifts. Engaging with them in this way has been a key step on our path from promise to progress. 50 - T HE F I V E L ESSO N S W E L EA R N ED"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 50,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg52.jpg",
      "zoom": null,
      "content": `
        <h1 id="52-no" class="abs fancyCutBold 52-no" style="top: 109px; left: 318px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 9000, "preppend": "+", "comma": true}' ></h1>
        <div class="contentLinkNone abs" style="top: 403px; left: 62px; width: 569px; height: 421px;" onclick="Publish.openArticle(5)"></div>
        <div class="contentLinkNone abs" style="    top: 249px; left: 352px; width: 289px; height: 157px;" onclick="Publish.openArticle(5)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg52Anim = new TimelineMax();
          pg52Anim
            .fromTo(cOf("52-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("52-no")[0])}}, 1.3)
        }

        function onPageLeave() {
          pg52Anim.stop();
          resetNumbers("52-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "+9,000  communities committed to ending child marriage  Tostan  Countries: Gambia, Guinea-Bissau, Senegal Funded since 2019  Village Enterprise Country: Uganda Funded since 2016  Community-based and locally led, Village Enterprise’s poverty graduation programme helps people lift themselves out of extreme poverty by developing sustainable livelihoods. Participants are provided with financial support, as well as business and financial literacy training and ongoing mentoring, to help them launch three-person businesses and saving groups. We’ve been supporting Village Enterprise in Uganda, where it has been working since 2016. Today, its operations expand throughout rural sub-Saharan Africa with the goal of lifting 20 million people out of extreme poverty by 2030. Our relationship with Village Enterprise has evolved constantly over the years, blooming into a solid collaboration based on dialogue, transparency and trust. Beyond providing flexible funding, we’re proud to join strategic discussions or lend support during key application processes that have the potential to secure additional funds.  Tostan implements a three-year participatory programme that educates young people, adults, elders and religious leaders about human rights, health, sanitation, conflict resolution, economic empowerment and parenting. It also teaches basic literacy and numeracy skills. This communityled, collaborative model fosters social and behavioural change from the ground up, encouraging villagers to reconsider deeply entrenched and harmful practices. One of Tostan’s most celebrated results is the commitment by over 9,000 communities to end child marriage and female genital mutilation. We have supported Tostan in Senegal since 2018 and we are now funding it to reach over 107,500 people living in remote communities in Gambia, Senegal and Guinea-Bissau. We find our partnership with the organisation becomes an increasingly meaningful and genuine connection every year. To quote Tostan’s CEO, Elena Bonometti, our relationship has been “transformative”, breaking down barriers and pushing both parties to question ourselves and be honest about the challenges we face and the expectations involved. The outcome is a strong alliance that is more and more relevant to the communities we serve. T HE FIVE LES S ONS WE LEARNED - 51"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 51,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg53.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 53-title" style="top:586px;left:86px;" src="/a-decade-of-effective-philanthropy/en/static/_content/53-title-1.png">
        <img class="abs halfScale 53-title" style="top:727px;left:86px;" src="/a-decade-of-effective-philanthropy/en/static/_content/53-text-1.png">
        <div class="contentLinkNone abs" style="top: 581px; left: 79px; width: 575px; height: 246px;" onclick="Publish.openArticle(6)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg53Anim = new TimelineMax();
          pg53Anim
            .staggerFromTo(cOf("53-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg53Anim.stop();
          resetNumbers("53-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "Buildher, Kheyti, Healthy Learners and Proximity Designs have been supported so far  5. COMMIT TO RESULTS AND HOLD YOURSELF ACCOUNTABLE We operate in a sector where we can define our own path. We choose our mission and vision and we select our partners on our own terms. We can decide what success or failure should look like. If we are genuine about social progress and impact, we need rigorous data collection and to hold ourselves accountable by communicating our findings openly. We transparently and publicly clarify what results we’re expecting to see and why, celebrate our successes when we achieve them and share the failures when we don’t – turning these failures into collective learnings in the process. 52 - T HE F I V E L ESSO N S W E L EA R N ED"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 52,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg54.jpg",
      "zoom": null,
      "content": `
        <div class="contentLinkNone abs" style="    top: 383px; left: 62px; width: 569px; height: 445px;" onclick="Publish.openArticle(6)"></div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "IDinsight  Countries: India, Kenya, Myanmar, Zambia Funded since 2020  Non-profits deliver essential services to the world’s poorest populations. This critical work needs evidence to optimise programme design, improve implementation and maximise impact. IDinsight is a global advisory, data analytics and research organisation that helps development leaders generate and use evidence. Since 2020, we’ve supported IDinsight’s efforts to evolve its data and evidence tools. The organisation is also working with a number of our partner organisations, providing monitoring and evaluation support and tailored advisory services, including strengthening data systems, designing or improving data collection, analysis and visualisation, and articulating their path to impact through evidence-informed theories of change.  International Center for Research on Women Countries: Rwanda, Tanzania Funded since 2018  The International Center for Research on Women (ICRW) is a global research institute dedicated to tackling the challenges that women and girls face worldwide. Since 2018 we’ve been funding it to help reduce the knowledge and practice gap regarding men’s and boys’ engagement with promoting gender equality. Following ICRW’s research study “Gender equity and male engagement: it only works when everyone plays”, a field trial is being conducted to apply the lessons learned from this research and develop evidence-based strategies on the topic. The five-year trial is being conducted in Rwanda and Tanzania to put male engagement strategies to the test, incorporating them in traditional women empowerment programmes run by Women for Women International and Hand in Hand International. The results will be shared sector-wide to inform future programmes and funding decisions. T HE FIVE LES S ONS WE LEARNED - 53"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 53,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg55.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 55-title" style="top:246px;left:97px;" src="/a-decade-of-effective-philanthropy/en/static/_content/55-title-1.png">
        <img class="abs halfScale 55-title" style="top:98px;left:102px;" src="/a-decade-of-effective-philanthropy/en/static/_content/55-text-1.png">
        <img class="abs halfScale 55-title" style="top:498px;left:194px;" src="/a-decade-of-effective-philanthropy/en/static/_content/55-text-2.png">
        <img class="abs halfScale 55-title" style="top:681px;left:107px;" src="/a-decade-of-effective-philanthropy/en/static/_content/55-text-3.png">

        <div class="single-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/en/static/_content/2022-CP-COM-In-Our-Partners-Words-05.mp4')" style="top: 45px; left: 476px;">
          <img class="abs 55-play halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/en/static/_content/play-big.png">
        </div>

        <div class="double-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/en/static/_content/2022-CP-COM-In-Our-Partners-Words-05.mp4')" style="top: 318px; left: 615px;">
          <img class="abs 55-play halfScaleC animatedpulse" src="/a-decade-of-effective-philanthropy/en/static/_content/play-big.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg55Anim = new TimelineMax();
          pg55Anim
            .staggerFromTo(cOf("55-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("55-play"), 0.9, {className: '+= halfpulseBig', opacity:0, scale: 0}, {opacity: 1, scale: 0.5, ease: Power2.easeOut}, ">")
          
          if (Publish.isDoublePage) {
            cOf("single-play")[0].style.display = "none"
            cOf("single-play")[1].style.display = "none"
            cOf("double-play")[0].style.display = "block"
          } else {
            cOf("single-play")[0].style.display = "block"
            cOf("single-play")[1].style.display = "block"
            cOf("double-play")[0].style.display = "none"
          }
        }

        function onPageLeave() {
          pg55Anim.stop();
          resetNumbers("55-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "C ATA LYT IC  “I would say catalytic because Cartier Philanthropy invests in solutions and ideas for right now that are hopefully changing the sector and the development space for the years to come.” Meg Battle, Director of Strategic Initiatives of IDinsight  HOW WOULD OUR PARTNERS DESCRIBE US? SOL ID ARI TY  “The word I would choose to describe Cartier Philanthropy is solidarity and that’s because the team understands that this work that we do together it isn’t about pity, it isn’t about some other person’s problems, it is about injustices, brokenness in a world that we all share responsibility for. It is about us solving those problems, solving these injustices together as partners of each other and as partners of the patients.” Ari Johnson, CEO of Muso  TR UST- IN-T RAN SFO RMATI O N  “I am going to cheat and I’m going to have hyphens: trust-in-transformation. Because Cartier Philanthropy funds strong organisations, but it trusts in them, it creates a space for the organisation to be what the organisation is designed to be, but also room to grow. And I think that’s the essence of trust.” Frank Beadle de Palomo, President and CEO of mothers to mothers  54 -"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 54,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg56.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 56-title" style="top:98px;left:217px;" src="/a-decade-of-effective-philanthropy/en/static/_content/56-text-1.png">
        <img class="abs halfScale 56-title" style="top:227px;left:109px;" src="/a-decade-of-effective-philanthropy/en/static/_content/56-text-2.png">
        <img class="abs halfScale 56-title" style="top:394px;left:223px;" src="/a-decade-of-effective-philanthropy/en/static/_content/56-text-3.png">
        <img class="abs halfScale 56-title" style="top:544px;left:152px;" src="/a-decade-of-effective-philanthropy/en/static/_content/56-text-4.png">
        <img class="abs halfScale 56-title" style="top:688px;left:94px;" src="/a-decade-of-effective-philanthropy/en/static/_content/56-text-5.png">
        <div class="single-play play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/en/static/_content/2022-CP-COM-In-Our-Partners-Words-05.mp4')" style="top: 18px; left: 6px;">
          <img class="abs 56-play halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/en/static/_content/play-big.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg56Anim = new TimelineMax();
          pg56Anim
            .staggerFromTo(cOf("56-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1.15)
            .fromTo(cOf("56-play"), 0.9, {className: '+= halfpulseBig', opacity:0, scale: 0}, {opacity: 1, scale: 0.5, ease: Power2.easeOut}, ">")

          
          if (!Publish.isDoublePage) {
            cOf("single-play")[0].style.display = "block"
            cOf("single-play")[1].style.display = "block"
            cOf("double-play")[0].style.display = "none"
          }
        }

        function onPageLeave() {
          pg56Anim.stop();
          resetNumbers("56-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "E MPATHY  “Definitely empathy, as I think you’ve taken a lot of time to listen and understand what’s going on with your grantees and on the ground.” Debbie Aung Din, Co-founder of Proximity Design  ONG OING LEARN I N G  “Cartier Philanthropy has demonstrated the commitment to ongoing learning and that’s a value that aligns with Room to Read as we’re both committed to meet the demands of the world as it changes. We’re not fixed in our beliefs, we continue to take feedbacks from the communities we serve and ensure that the learning continues.” Geetha Murali, CEO of Room to Read  T HOUGHTFUL  “I would choose thoughtful. I think Cartier Philanthropy is very thoughtful in who they choose and in how they partner and in how they trust their grantees to make decisions about what’s going to have the most impact.” Emily Bancroft, President of Village Reach  I MPA CT  “The one word is impact and it’s very much through an evidence-based learning, so a very reflexive philanthropy that is really seeking to figure out how do we make this a better world.” Laurie Adams, CEO of Women for Women International  T R A NSFORMATI VE  “I would choose transformative. The relationship has been transformative because Cartier Philanthropy’s team has always pushed us to really question the way we work in a way that has been constructive and really accompanied us to do a better work and more relevant for the people that we serve.” Elena Bonometti, CEO of Tostan  - 55"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 55,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg57.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 57-title" style="top:431px;left:89px;" src="/a-decade-of-effective-philanthropy/en/static/_content/57-title-1.png">
        <img class="abs halfScale 57-title" style="top:464px;left:90px;" src="/a-decade-of-effective-philanthropy/en/static/_content/57-title-2.png">
        <img class="abs halfScaleC 57-text" style="top:-467px;left:-148px;" src="/a-decade-of-effective-philanthropy/en/static/_content/57-text-1.png">
        <img class="abs halfScaleC 57-text" style="top:182px;left:-70px;" src="/a-decade-of-effective-philanthropy/en/static/_content/57-text-2.png">
      `,
      "script": `
        function onPageEnter() {
          pg57Anim = new TimelineMax();
          pg57Anim
            .staggerFromTo(cOf("57-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1.3)
            .staggerFromTo(cOf("57-text"), 1, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 0.3, 1.9)
        }

        function onPageLeave() {
          pg57Anim.stop();
          resetNumbers("57-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACCESS TO BASIC SERVICES Education Ashesi University CorStone European Institute for Cooperation and Development (IECD) Imagine Worldwide The Luminos Fund Ubongo  Water, Sanitation, Nutrition 1001fontaines Semilla Nueva SOIL Water and Sanitation for the Urban Poor (WSUP)  Health Development Media International (DMI) Healthy Learners Integrate Health MiracleFeet Muso Pivot UNFPA Supplies Partnership VillageReach  PORTFOLIO  PARTNERS 2022 SUSTAINABLE LIVELIHOODS AND ECOSYSTEMS BRAC Fonkoze Foundation Hand in Hand International  56 -  Kheyti myAgro One Acre Fund Proximity Designs  Root Capital Village Enterprise VisionSpring World Bicycle Relief"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 56,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg58.jpg",
      "zoom": null,
      "content": `
      <img class="abs halfScaleC 58-text" style="top:-467px;left:-862px;" src="/a-decade-of-effective-philanthropy/en/static/_content/57-text-1.png">
      <img class="abs halfScaleC 58-text" style="top:182px;left:-783px;" src="/a-decade-of-effective-philanthropy/en/static/_content/57-text-2.png">
      <img class="abs halfScaleC 58-text" style="top:-327px;left:-207px;" src="/a-decade-of-effective-philanthropy/en/static/_content/58-text-1.png">
      <img class="abs halfScaleC 58-text" style="top:241px;left:-210px;" src="/a-decade-of-effective-philanthropy/en/static/_content/58-text-2.png">
      <img class="abs halfScaleC 58-text" style="top:566px;left:347px;" src="/a-decade-of-effective-philanthropy/en/static/_content/58-text-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg58Anim = new TimelineMax();
          pg58Anim
            .staggerFromTo(cOf("58-text"), 1, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 0.3, 1.9)
        }

        function onPageLeave() {
          pg58Anim.stop();
          resetNumbers("58-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "WOMEN’S SOCIAL AND ECONOMIC DEVELOPMENT  a )  Co-Impact Women’s health mothers2mothers MSI Reproductive Choices (MSI) StrongMinds  Economic opportunities The BOMA Project International Center for Research on Women (ICRW) Saha Global Women for Women International  EMERGENCY RESPONSE International Rescue Committee (IRC) Medair Médecins Sans Frontières (MSF)  World Food Programme (WFP) SOS Méditerranée  Education & Life Skills Asian University for Women Buildher Educate Girls Room to Read Tostan  TECHNICAL SUPPORT Appleseed IDinsight  - 57"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 57,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg59.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="top: 739px; left: 83px; width: 196px; height: 20px;"> <a href="https://www.cartierphilanthropy.org" target="_blank"></a> </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Photo credits Cover: © Cartier Philanthropy / Cyril Le Tourneur © 1001Fontaines (p. 13) © Action Against Hunger / Lucile Grosjean (p. 36) © The BOMA Project (p. 21) © Buildher (p. 48) © Cartier Philanthropy / Andrea Borgarello (p. 12, 19, 24-25, 23, 29, 32, 38, 43, 46) © Cartier Philanthropy / Cyril Le Tourneur (p. 14, 16, 18, 23, 27, 42) © Cartier Philanthropy / Irene Amodei (p. 33) © Cartier Philanthropy / Karin Schermbrucker (p.1, 7, 17, 44) © CorStone (p. 10) © Hand in Hand International / Georgina Goodwin (p. 49) © Healthy Learners (p. 45) © International Federation of the Red Cross and Red Crescent Societies (p. 36) © International Rescue Committee (p. 11) © International Rescue Committee / A. Oberstadt Richmond (p. 33) © Integrate Health (p. 8)  Address Rue André-De-Garrini 3 – CH-1217 Meyrin-Geneva  Website www.cartierphilanthropy.org  58 -  © The Luminos Fund / Rosie Hallam (p. 41) © The Luminos Fund / Aron Simeneh (p.10) © Medair / Megan Fraga (p. 31) © Medair (p. 35) © Medair /Chrystelle Rakotomavo (p. 37) © Médecins Sans Frontières / Agnes Varraine Leca (p. 35) © Médecins Sans Frontières / Benoit Finck (p. 37) © Médecins Sans Frontières / Premananda Hessenkamp (p. 35) © mothers2mothers / Karin Schermbrucker (p. 40) © One Acre Fund / Hailey Tucker (p. 27) © Pivot (p. 9) © Root Capital (p. 26) © Saha Global (p. 20) © Semilla Nueva (p. 12) © SOIL / Vic Hinterlang (p. 12) © StrongMinds / Jennifer Bass (p. 16) © SOS Méditerranée / Hara Kaminara (p. 32) © Techo (p. 34) © Tostan (p. 47) © Women for Women International/Hazel Thomson (p. 20) © World Bicycle Relief (p. 28)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 58,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg60.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))
        
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
        contentLinksThree.map(function callback(e) { 
          return e.className = 'addContentLinkThree'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))

        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
        contentLinksThree.map(function callback(e) {
          return e.className = 'contentLinkThree addContentLinkThree'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^\d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/\.\d+/) ? str.split(/\.\d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function animateNumbers(klass, delay = 1, stagger = 0.3) {
        numbers = cOf(klass)
      
        setTimeout(function() {
          for (let i = 0; i < numbers.length; i++) {
            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])
          }
        }, delay * 1000)
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }

      function individualGallery(index) {
        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
    "articles": [{
      "title": "MESSAGE FROM THE PRESIDENT",
      "pageIndex": 6,
      "subIndex": 0,
      "articleIndex": 0,
      "article": `
        <h2>MESSAGE FROM THE PRESIDENT</h2>  

        <p>Cartier’s mission is to find beauty wherever it may lie. We serve beauty and work to honour it every day, so it can flourish and last for generations.</p>
        <p>We see it as our responsibility, both as human beings and as a company, to nurture and protect the world’s beauty, making every effort to restore it when it has been eroded or shattered. And we see human life as an integral part of the beauty of the world.</p>
        <p>Beauty, as we conceive of it, is thus a demanding ideal that can only be served through care, respect, dignity and compassion.</p>
        <p>Over the past 10 years, Cartier Philanthropy has worked tenaciously and effectively to improve the lives of the most vulnerable and marginalised communities on the planet, so that they are not only able to endure and survive hardship, but to live, enjoy and fully participate in the beauty of the world. A girl that successfully finishes her education, a thriving farming community, a safe place to find sanctuary and rebuild a new life, a healthy baby… These are all beauty. Living beauty.</p>
        <p>Cartier Philanthropy has been supporting organisations whose mission is to empower women, children and entire communities with the resources, skills and opportunities they need to live fulfilling lives. Strong long-term alliances have been created along the way, based on shared values and a mutual commitment to impactful philanthropy.</p>
        <p>The road ahead is still long. Indeed, on some days it can seem longer than it did 10 years ago. But every step forward and every life changed reaffirms our confidence and determination, while opening the way for others to join us in creating new beauty in the world.</p>

        <p>
          <b>Cyrille Vigneron</b><br>
          CEO of Cartier,<br>
          President of the Board,<br>
          Cartier Philanthropy
        </p>
      `,
    },{
      "title": "STRATEGIC ADVISOR’S MESSAGE",
      "pageIndex": 7,
      "subIndex": 0,
      "articleIndex": 1,
      "article": `
        <h2>STRATEGIC ADVISOR’S MESSAGE</h2> 
        <p>What a journey the last 10 years have been!</p>
        <p>And what a privilege it has been to lead Cartier Philanthropy from promise to progress, building a portfolio of partner organisations of which we are incredibly proud.</p>
        <p>It’s a source of joy to see empowered and resourceful communities across the world overcoming great obstacles and once insurmountable barriers as they begin to live the lives they deserve.</p>
        <p>Ten years ago, Cartier Philanthropy was founded to help build a world in which everyone can realise their potential. Over the past decade, we’ve focused on that vision strategically. We’ve chosen to concentrate on the most fragile places on Earth and we’ve gradually defined the perimeter of the issues we wanted to tackle, challenging in particular the inequalities that keep people in poverty.</p>
        <p>Philanthropy is all about collective action in pursuit of shared goals. In collaboration with our partners, we have tried to address these inequalities relentlessly, whether linked to gender, access to essential services or lack of material and social resources. This report sheds light on the impact we have achieved together and on the concrete changes that have contributed to improving the lives of those most in need. It is our way of honouring our partner organisations for their courage and determination to fight for the people they serve, no matter the difficulties - for their struggles are ours too.</p>
        <p>Conscious that true, lasting change only happens if we focus also on how we give in order to contribute to significant social impact, this report also shares some of the lessons we have learned along the way, helping us to become a better, more effective, accountable and collaborative foundation.</p>
        <p>Achieving an inclusive, equitable and safer society that offers everyone a chance to live a fulfilling life remains a moral imperative and the challenge of our time. Our commitment to get there is unchanged, as is our ambition to scale the interventions that work to match the level of need.</p>
        <p>
          <b>Pascale de la Frégonnière</b><br>
          Strategic Advisor to the Board,<br>
          Cartier Philanthropy
        </p>
      `,
    },{
      "title": "1. FUND IMPACT",
      "pageIndex": 43,
      "subIndex": 0,
      "articleIndex": 2,
      "article": `
        <h2>1. FUND IMPACT.</h2> 
        <p>There’s too much to do in the world today – and too much urgency to support people living in poverty – to waste any money, time or energy on development programmes or interventions that don’t work.</p>
        <p>Our number one responsibility as funders is to make sure that every dollar we spend helps to create positive, concrete, verifiable change in the lives of the people we strive to serve. For that to happen, we need to support proven solutions, backed by data-driven evidence, that will lead to impactful results.</p>
        <p>Partner: <b>mothers2mothers</b><br>
        Country: Uganda<br>
        Funded since 2017</p>
        <p>mothers2mothers (m2m) employs women living with HIV to help other women and their families access essential services and medical care. Preventing HIV infection and related diseases is a key focus of the programme. Since 2017, our funding has allowed m2m to scale up its integrated health services in Uganda to prevent HIV-positive pregnant women from transmitting the virus to their baby and maintaining the health of women and children.</p>
        <p>In the past 20 years, m2m’s work has resulted in the virtual elimination of mother-to-child transmission of HIV among the women they serve. Among m2m’s clients in east and southern Africa, the mother-to-child HIV transmission rate has dropped from 40% to 0.8% and child mortality has reduced to two deaths per 1,000 live births.</p>
        <p>Partner: <b>The Luminos Fund</b><br>
        Country: Ethiopia<br>
        Funded since 2018</p>
        <p>The Luminos Fund’s Second Chance accelerated learning programme has already enabled over 152,000 African children who never attended school or were forced to drop out because of poverty, conflict or discrimination to return to lessons. Since 2018, we’ve been supporting the rapid expansion of the programme across the remote Afar and Oromia regions of Ethiopia.</p>
        <p>Between 91% and 97% of the 26,850 children enrolled in Second Chance classes between 2018 and 2021 successfully transitioned to state schools to continue their education. 9,000 more children were enrolled in government-run versions of the Second Chance programme. 75% of Second Chance students are still attending school after 6 years.</p>
      `,
    },{
      "title": "2. THINK LONG-TERM AND UNRESTRICTED FUNDING",
      "pageIndex": 45,
      "subIndex": 0,
      "articleIndex": 3,
      "article": `
        <h2>2. THINK LONG-TERM AND UNRESTRICTED FUNDING.</h2> 
        <p>We work on complex, multi-faceted issues and, as such, we don’t expect to solve them overnight. We’re in it for the long term. A focus on two- to three-year projects often just leads to a tick-box approach. Instead, we’ve chosen to commit to strong alliances and long-term funding, supporting our partner organisations to keep growing, deepening their impact and expanding their geographical scope of operations. Providing unrestricted funding, which non-profits can spend any way they believe is appropriate, is perhaps the single most transformational move we can make to truly help our partners deliver on their missions.</p>
        <p>Partner: <b>Educate Girls</b><br>
        Country: India<br>
        Funded since 2014</p>
        <p>Educate Girls tackles the gender and literacy gap in rural India’s education system, bringing out-of-school girls back to mainstream education. From an initial pilot project of 50 schools in 2007, it currently operates in over 20,000 villages in Rajasthan, Madhya Pradesh and Uttar Pradesh.</p>
        <p>Educate Girls has consistently achieved impressive enrolment, retention and learning outcomes over the years. Household visits and community outreach are at the heart of the organisation’s success. Educate Girls also taps into government resources to improve schools’ infrastructure, governance and teaching.</p>
        <p>As part of our long-term alliance with Educate Girls, we’ve funded their unique approach since 2014 and contributed to the enrolment of over 1.1 million girls worldwide. We’re now supporting the organisation’s bold goal to scale to 1.5 million by 2024.</p>
        <p>Partner: <b>Room to Read</b><br>
        Country: Bangladesh, Cambodia, global<br>
        Funded since 2019</p>
        <p>Room to Read seeks to transform the lives of millions of children in low-income communities by focusing on literacy and gender equality in education. Working with local communities, partner organisations and governments, the organisation develops literacy skills and instils the habit of reading among primary school children.</p>
        <p>We’ve been supporting Room to Read Girls’ Education programme in Bangladesh and Cambodia since 2019, enabling adolescent girls to learn and practise life skills through classes, workshops and extracurricular activities, with the aim to encourage them to pursue their education and create the future they want. Since July 2022, we’ve been funding the organisation unrestrictedly.</p>
      `,
    },{
      "title": "3. INNOVATION IS GREAT, BUT SCALING PROVEN SOLUTIONS IS EVEN BETTER",
      "pageIndex": 47,
      "subIndex": 0,
      "articleIndex": 4,
      "article": `
        <h2>3. INNOVATION IS GREAT, BUT SCALING PROVEN SOLUTIONS IS EVEN BETTER.</h2> 
        <p>Given the urgency and intensity of today’s social problems, if the whole philanthropic community is seduced by the excitement of innovation and focuses solely on that, then we’ll never be able to take the proven solutions that already exist to scale. In other words, we don’t need another million innovations. We just need one that works, scaled a million times so that its impact grows to match the level of need.</p>
        <p>Partner: <b>StrongMinds</b><br>
        Country: Uganda, Zambia<br>
        Funded since 2018</p>
        <p>The WHO endorses group interpersonal psychotherapy as a front-line mental health intervention for vulnerable populations. StrongMinds is the only organisation scaling this cost-effective solution to help end the depression epidemic in Africa.</p>
        <p>StrongMinds trains and supervises community workers to become mental health facilitators and lead group therapy sessions. These sessions are designed to support women with depression in poor communities, where the prevalence of depression is as high as 25%. Groups of 10-15 women meet for weekly 90-minute sessions where they learn how to identify the triggers of depression, share strategies to overcome their symptoms and build long-term resilience. StrongMinds’ model enables women who have completed their group therapy sessions to be trained to lead their own peer therapy groups, multiplying the organisation’s impact.</p>
        <p>Since 2018, we have been supporting StrongMinds to replicate the model it developed in Uganda in Zambia. StrongMinds is now poised to become the Zambian Ministry of Health’s technical advisor on mental health.</p>
        <p>Partner: <b>Healthy Learners</b><br>
        Country: Zambia<br>
        Funded since 2019</p>
        <p>Healthy Learners works to improve the health of children over five years through a school-based community health programme. The organisation trains teachers to recognise symptoms of common diseases in students and provide them with rapid treatment or refer them to health centres. This ensures that sick children are identified and treated quickly, reducing their morbidity and the duration of their absence from school.</p>
        <p>Since we started supporting them in 2019, Healthy Learners has systematised this model and strengthened its collaboration with the Zambian government’s Ministries of Health and Education to scale it as a national school health programme.</p>
      `,
    },{
      "title": "4. FIND THE RIGHT BALANCE IN THE POWER DYNAMIC",
      "pageIndex": 47,
      "subIndex": 0,
      "articleIndex": 5,
      "article": `
        <h2>4. FIND THE RIGHT BALANCE IN THE POWER DYNAMIC.</h2> 
        <p>When it comes to shifting and improving giving practices, the onus is on funders. Power dynamics dictate that funders must be the one to reimagine their relationship with grantees, starting by recognising the inherent power imbalance that can inhibit honest and fruitful collaboration. Our partners need us to be flexible, pragmatic, open to learning about their needs and challenges, and ready to leverage their work publicly. Most of all, though, they need us to trust them. Over the years, we’ve intentionally created time and space for conversations where our partners can feel free to express doubts, question requests and present strategy shifts. Engaging with them in this way has been a key step on our path from promise to progress.</p>
        <p>Partner: <b>Village Enterprise</b><br>
        Country: Uganda<br>
        Funded since 2016</p>
        <p>Community-based and locally led, Village Enterprise’s poverty graduation programme helps people lift themselves out of extreme poverty by developing sustainable livelihoods. Participants are provided with financial support, as well as business and financial literacy training and ongoing mentoring, to help them launch three-person businesses and saving groups. </p>
        <p>We’ve been supporting Village Enterprise in Uganda, where it has been working since 2016. Today, its operations expand throughout rural Sub-Saharan Africa with the goal of lifting 20 million people out of extreme poverty by 2030. Our relationship with Village Enterprise has constantly evolved over the years, blooming into a solid collaboration based on dialogue, transparency and trust. Beyond providing flexible funding, we’re proud to join strategic discussions or lend support during key application processes that have the potential to secure additional funds.</p>
        <p>Partner: <b>Tostan</b><br>
        Country: Gambia, Senegal and Guinea-Bissau<br>
        Funded since 2016</p>
        <p>Tostan implements a three-year participatory programme which educates young people, adults, elders and religious leaders about human rights, health, sanitation, conflict resolution, economic empowerment and parenting. It also teaches basic literacy and numeracy skills. This community-led, collaborative model fosters social and behavioural change from the ground up, encouraging villagers to reconsider deeply entrenched and harmful practices. One of Tostan’s most celebrated results is the commitment by over 9,000 communities to end child marriage and female genital mutilation.</p>
        <p>We have supported Tostan in Senegal since 2018 and we are now funding them to reach over 107,500 people living in remote communities in Gambia, Senegal and Guinea-Bissau. We find our partnership with the organisation becomes an increasingly meaningful and genuine connection every year. To quote Tostan’s CEO Elena Bonometti, our relationship has been “transformative”, breaking down barriers and pushing both to question ourselves and be honest about the challenges we face and the expectations involved. The outcome is a strong alliance that is more and more relevant to the communities we serve.</p>
      `,
    },{
      "title": "5. COMMIT TO RESULTS AND HOLD YOURSELF ACCOUNTABLE",
      "pageIndex": 47,
      "subIndex": 0,
      "articleIndex": 6,
      "article": `
        <h2>5. COMMIT TO RESULTS AND HOLD YOURSELF ACCOUNTABLE.</h2> 
        <p>We operate in a sector where we can define our own path. We choose our mission and vision and we select our partners on our own terms. We can decide what success or failure should look like. If we are genuine about social progress and impact, we need rigorous data collection and to hold ourselves accountable by communicating our findings openly. We transparently and publicly clarify what results we’re expecting to see and why, celebrate our successes when we achieve them and share the failures when we don’t – turning these failures into collective learnings in the process.</p>
        <p>Partner: <b>IDinsight</b><br>
        Country: India, Myanmar, Kenya, Zambia<br>
        Funded since 2020</p>
        <p>Non-profits deliver essential services to the world’s poorest populations. This critical work needs evidence to optimise programme design, improve implementation and maximise impact.</p>
        <p>IDinsight is a global advisory, data analytics, and research organisation that helps development leaders generate and use evidence.</p>
        <p>Since 2020, we’ve supported IDinsight’s efforts to evolve their data and evidence tools. The organisation is also working with a number of our partner organisations, providing monitoring and evaluation support and tailored advisory services, including strengthening data systems, designing or improving data collection, analysis and visualisation, and articulating their path to impact through evidence-informed theories of change.</p>
        <p>Partner: <b>International Center for Research on Women</b><br>
        Country: Rwanda, Tanzania<br>
        Funded since 2018</p>
        <p>The International Center for Research on Women (ICRW) is a global research institute dedicated to tackling the challenges that face women and girls worldwide. Since 2018 we’ve been funding them to help fill the knowledge and practice gap regarding men’s and boys’ engagement with promoting gender equality.</p>
        <p>Following ICRW’s research study “Gender equity and male engagement: it only works when everyone plays”, a field trial is being conducted to apply the lessons learned from this research and develop evidence-based strategies on the topic. The five-year trial is being conducted in Rwanda and Tanzania to put male engagement strategies to the test, incorporating them in traditional women empowerment programmes run by Women for Women International and Hand in Hand International. The results will be shared sector-wide to inform future programmes and funding decisions.</p>
      `,
    }]}



// WEBPACK FOOTER //
// ./src/document.js